// 22 Verticals of Higher Education in India (SGIS Career Counsellor framework).
// Data sourced from the counsellor's official vertical guides.
// c(rank, name, location, admission, url) helper keeps college rows compact.
const c = (rank, name, location, admission, url, tag) => ({ rank, name, location, admission, url, tag });

export const VERTICALS = [
  {
    slug: "arts-humanities-social-sciences",
    name: "Arts, Humanities & Social Sciences",
    category: "Liberal Arts",
    icon: "BookOpen",
    comingSoon: false,
    overview:
      "The humanities study how people process and document the human experience — through philosophy, literature, history, religion, art, music and language. Skills acquired here are versatile and apply across sectors, giving students a deep sense of connection to culture and society.",
    degrees: [
      { name: "BA (Bachelor of Arts) — various specializations", duration: "3 Years", eligibility: "10+2 any stream" },
      { name: "BA (Hons.)", duration: "3/4 Years", eligibility: "10+2 any stream" },
      { name: "BSW (Bachelor of Social Work)", duration: "3 Years", eligibility: "10+2 any stream" },
      { name: "BRS (Bachelor of Rural Studies)", duration: "3 Years", eligibility: "10+2 any stream" },
      { name: "BA + MA (Integrated) — various specializations", duration: "5 Years", eligibility: "10+2 any stream" },
    ],
    specializations: [
      "Anthropology", "Defence & National Security", "Journalism & Mass Media", "Museology", "Psychology",
      "Archaeology", "Developmental Studies", "Geography", "Languages", "Philosophy", "Public Administration",
      "Economics", "History", "Literature", "Physical Education", "Rural Studies", "Social Work", "Education",
      "International Relations", "Linguistics", "Political Science", "Sociology",
    ],
    careers: [
      "Indian Civil Services", "Government Organizations", "Banking / Insurance", "Indian Armed Forces",
      "Start own Venture", "Higher Studies", "Research and Academics", "Social Service / NGO",
      "Archaeological Survey of India", "Corporate / Private Jobs", "Social Research", "Higher Studies in Management",
    ],
    exams: [
      { name: "CUET (UG)", url: "https://cuet.samarth.ac.in/" },
      { name: "HSEE (IIT-Madras)", url: "https://hsee.iitm.ac.in/" },
      { name: "TISS-BAT", url: "https://www.tiss.edu/" },
      { name: "CUET (Christ University)", url: "https://christuniversity.in/" },
      { name: "BA-CET (IPU)", url: "http://www.ipu.ac.in/" },
      { name: "AMU-ET", url: "https://www.amu.ac.in/" },
      { name: "AAT (Ashoka Aptitude Test)", url: "https://www.ashoka.edu.in/" },
      { name: "SSSIHL-UGT", url: "https://www.sssihl.edu.in/" },
      { name: "SNUSAT + APT", url: "https://home.pearsonvue.com/snu" },
      { name: "APU-ET (Azim Premji)", url: "https://azimpremjiuniversity.edu.in/" },
      { name: "JMI-ET", url: "https://www.jmi.ac.in/" },
      { name: "KIIT-EE", url: "https://kiit.ac.in/" },
      { name: "UG-JET (Jain)", url: "https://www.jainuniversity.ac.in/" },
      { name: "JSAT (Jindal)", url: "https://home.pearsonvue.com/jsat.aspx" },
      { name: "BHU-UET", url: "https://www.bhu.ac.in/" },
      { name: "MITWPU-UGPET", url: "https://mitwpu.edu.in/" },
    ],
    colleges: [
      c(1, "IIT Madras", "Chennai", "HSEE", "https://hsee.iitm.ac.in/"),
      c(2, "Hindu College", "Delhi", "CUET (UG)", "http://www.hinducollege.ac.in/"),
      c(3, "Lady Shri Ram College for Women", "Delhi", "CUET (UG)", "https://lsr.edu.in/"),
      c(4, "Miranda House", "Delhi", "CUET (UG)", "https://www.mirandahouse.ac.in/"),
      c(5, "St. Stephen's College", "Delhi", "CUET (UG)", "https://www.ststephens.edu/"),
      c(6, "Sri Ram College of Commerce", "Delhi", "CUET (UG)", "https://www.srcc.edu/"),
      c(7, "St. Xavier's College", "Mumbai", "Based on 12th Marks", "https://sxcbom.com/"),
      c(8, "Christ University", "Bangalore", "CUET", "https://www.christuniversity.in/"),
      c(9, "Loyola College", "Chennai", "Based on 12th Marks", "https://www.loyolacollege.edu/"),
      c(10, "Madras Christian College", "Chennai", "Based on 12th Marks", "http://mcc.edu.in/"),
      c(11, "Hansraj College", "Delhi", "CUET (UG)", "https://www.hansrajcollege.ac.in/"),
      c(12, "Ramjas College", "Delhi", "CUET (UG)", "https://ramjas.du.ac.in/"),
      c(13, "Stella Maris College", "Chennai", "Based on 12th Marks", "https://stellamariscollege.edu.in/"),
      c(14, "Gargi College", "Delhi", "CUET (UG)", "http://www.gargi.du.ac.in/"),
      c(15, "Mithibai College of Arts", "Mumbai", "Based on 12th Marks", "https://www.mithibai.ac.in/"),
      c(16, "K.J. Somaiya College of Arts & Comm.", "Mumbai", "Based on 12th Marks", "https://kjsac.somaiya.edu.in/"),
      c(17, "St. Joseph's College", "Bengaluru", "Based on 12th Marks", "https://www.sjc.ac.in/"),
      c(18, "Indraprastha College for Women", "Delhi", "CUET (UG)", "http://www.ipcollege.ac.in/"),
      c(19, "Atma Ram Sanatan Dharma College", "Delhi", "CUET (UG)", "https://www.arsdcollege.ac.in/"),
      c(20, "Daulat Ram College", "Delhi", "CUET (UG)", "http://www.dr.du.ac.in/"),
      c(21, "Women's Christian College", "Chennai", "Based on 12th Marks", "https://wcc.edu.in/"),
      c(22, "Sri Venkateswara College", "Delhi", "CUET (UG)", "http://www.svc.ac.in/"),
      c(23, "St. Xavier's College", "Ahmedabad", "Based on 12th Marks", "https://sxca.edu.in/"),
      c(24, "Ethiraj College for Women", "Chennai", "Based on 12th Marks", "https://ethirajcollege.edu.in/"),
      c(25, "Mount Carmel College", "Bangalore", "Based on 12th Marks", "https://mccblr.edu.in/"),
      c(26, "Sophia College for Women", "Mumbai", "Based on 12th Marks", "https://sophiacollegemumbai.com/"),
      c(27, "M.C.M. D.A.V. College for Women", "Chandigarh", "Based on 12th Marks", "https://mcmdavcwchd.edu.in/"),
      c(28, "St. Francis College for Women", "Hyderabad", "Based on 12th Marks", "https://www.sfc.ac.in/"),
      c(29, "Kristu Jayanti College", "Bangalore", "Based on 12th Marks", "https://kristujayanti.edu.in/"),
      c(30, "Symbiosis College of Arts and Commerce", "Pune", "Based on 12th Marks", "https://symbiosiscollege.edu.in/"),
      c(31, "Kamala Nehru College for Women", "Delhi", "CUET (UG)", "https://knc.edu.in/"),
      c(32, "Sacred Heart College", "Kochi", "Based on 12th Marks", "https://www.shcollege.ac.in/"),
      c(33, "Goswami Ganesh Dutta S.D. College", "Chandigarh", "Based on 12th Marks", "http://ggdsd.ac.in/"),
      c(34, "D.A.V. College Sec 10", "Chandigarh", "Based on 12th Marks", "https://www.davchd.ac.in/"),
      c(35, "Delhi College of Arts & Commerce", "Delhi", "CUET (UG)", "http://www.dcac.du.ac.in/"),
      c(36, "Deen Dayal Upadhyaya College", "Delhi", "CUET (UG)", "https://dducollegedu.ac.in/"),
      c(37, "Tata Institute of Social Sciences", "Tuljapur", "TISS-BAT", "https://www.tiss.edu/"),
      c(38, "St. Teresa's College", "Kochi", "Based on 12th Marks", "https://teresas.ac.in/"),
      c(39, "St. Xavier's College", "Ranchi", "Xavier's ET", "https://www.sxcran.org/"),
      c(40, "Maharaja Agrasen College", "Delhi", "CUET (UG)", "http://www.mac.du.ac.in/"),
      c(41, "S.K. Somaiya College of Arts & Comm.", "Mumbai", "Based on 12th Marks", "https://sksasc.somaiya.edu.in/"),
      c(42, "Isabella Thoburn College", "Lucknow", "Entrance Test", "https://www.itcollege.ac.in/"),
      c(43, "St. Mira's College for Girls", "Pune", "Based on 12th Marks", "https://www.stmirascollegepune.edu.in/"),
      c(44, "PG Government College for Girls", "Chandigarh", "Based on 12th Marks", "http://www.gcg11.ac.in/"),
      c(45, "Kirori Mal College", "Delhi", "CUET (UG)", "http://www.kmcollege.ac.in/"),
      c(46, "Maitreyi College", "Delhi", "CUET (UG)", "http://maitreyi.ac.in/"),
      c(47, "Kishinchand Chellaram College", "Mumbai", "Based on 12th Marks", "https://www.kccollege.edu.in/"),
      c(48, "Lakshmibai College", "Delhi", "CUET (UG)", "https://lakshmibaicollege.in/"),
      c(49, "Shiv Nadar University", "Delhi NCR", "SNUSAT", "https://www.snuadmissions.com/"),
      c(50, "St. Ann's College for Women", "Hyderabad", "Based on 12th Marks", "http://www.stannscollegehyd.com/"),
    ],
  },
  {
    slug: "business-management",
    name: "Business Management",
    category: "Management",
    icon: "Briefcase",
    comingSoon: false,
    overview:
      "A course in Business Management equips you with knowledge of Marketing, Human Resources, Finance, Operations, IT, Business Policy, Consulting and Strategy. Students develop rational thinking, problem-solving, structured decision-making and leadership, and can later specialize in a chosen area.",
    degrees: [
      { name: "BBA (Bachelor of Business Administration)", duration: "3/4 Years", eligibility: "10+2 any stream" },
      { name: "BBA (Hons.)", duration: "3/4 Years", eligibility: "10+2 any stream" },
      { name: "BMS (Bachelor of Management Studies)", duration: "3/4 Years", eligibility: "10+2 any stream" },
      { name: "BMS (Hons.)", duration: "3/4 Years", eligibility: "10+2 any stream" },
      { name: "BBA + MBA (Integrated)", duration: "4/5 Years", eligibility: "10+2 any stream" },
    ],
    specializations: [
      "Financial Accounting", "Event Management", "Hospitality Management", "International Business",
      "Retail Management", "Finance", "Family Business & Entrepreneurship", "Human Resources",
      "Management Communications", "Systems & Operations", "General Management", "Foreign Trade",
      "Import-Export Management", "Marketing & Advertising", "Tourism Management",
      "Digital Marketing Management", "Hospital Administration", "Infrastructure Management", "Marketing Management",
    ],
    careers: [
      "Government / Public Sector Jobs", "MNC / Corporate Job", "Work for an NGO",
      "International Business / Consultancy", "Merchant Navy", "Indian Armed Forces",
      "Entrepreneurship / Family Business", "Higher Studies in Economics/Finance", "Research and Academics",
      "Banking / Insurance", "Indian Civil Services", "Higher Studies in Management",
    ],
    exams: [
      { name: "IPM-AT (IIM Indore & Ranchi)", url: "https://www.iimidr.ac.in/" },
      { name: "IPM-AT (IIM Rohtak)", url: "https://www.iimrohtak.ac.in/" },
      { name: "JIPMAT", url: "https://jipmat.nta.ac.in/" },
      { name: "CUET (UG)", url: "https://cuet.samarth.ac.in/" },
      { name: "NMIMS-NPAT", url: "https://nmimsnpat.in/" },
      { name: "UGAT (AIMA)", url: "https://apps.aima.in/" },
      { name: "CUET (Christ University)", url: "https://christuniversity.in/" },
      { name: "MET (Manipal)", url: "https://apply.manipal.edu/" },
      { name: "SET-General (Symbiosis)", url: "https://www.set-test.org/" },
      { name: "St. Xavier's-ET", url: "https://xaviers.edu/" },
      { name: "BU-MAT", url: "https://bvuniversity.edu.in/" },
      { name: "UG-JET (Jain)", url: "https://www.jainuniversity.ac.in/" },
      { name: "BBA-CET (IPU)", url: "http://www.ipu.ac.in/" },
      { name: "MSU-ET", url: "https://admission.msubaroda.ac.in/" },
      { name: "JMI-ET", url: "https://www.jmi.ac.in/" },
      { name: "SNUSAT + APT", url: "https://home.pearsonvue.com/snu" },
      { name: "JSAT (Jindal)", url: "https://jgu.edu.in/" },
      { name: "MITWPU-UGPET", url: "https://mitwpu.edu.in/" },
      { name: "OJEE Form A", url: "https://ojee.nic.in/" },
    ],
    colleges: [
      c(1, "Shaheed Sukhdev College of Business Studies", "New Delhi", "CUET (UG)", "http://www.sscbsdu.ac.in/"),
      c(2, "Christ University", "Bangalore", "CUET", "https://christuniversity.in/"),
      c(3, "Narsee Monjee (NMIMS)", "Mumbai", "NPAT", "https://commerce.nmims.edu/"),
      c(4, "Manipal University", "Manipal", "MET", "https://manipal.edu/"),
      c(5, "St. Xavier's College", "Mumbai", "St. Xavier's-ET", "https://www.xaviers.edu/"),
      c(6, "Jamia Millia Islamia", "New Delhi", "JMI-ET / CUET (UG)", "https://www.jmi.ac.in/"),
      c(7, "Banasthali University", "Jaipur", "Based on 12th Marks", "http://www.banasthali.org/"),
      c(8, "Madras Christian College", "Chennai", "Based on 12th Marks", "https://www.mcc.edu.in/"),
      c(9, "Mount Carmel College", "Bangalore", "Based on 12th Marks", "https://mccblr.edu.in/"),
      c(10, "Loyola College", "Chennai", "Based on 12th Marks", "https://www.loyolacollege.edu/"),
      c(11, "Mithibai College", "Mumbai", "Based on 12th Marks", "https://www.mithibai.ac.in/"),
      c(12, "Symbiosis Centre for Management Studies", "Pune", "SET", "https://www.scmspune.ac.in/"),
      c(13, "KIIT", "Bhubaneshwar", "KIIT-EE", "https://kiit.ac.in/"),
      c(14, "Indraprastha University (IPU)", "Delhi", "BBA-CET", "http://www.ipu.ac.in/"),
      c(15, "Keshav Mahavidyalaya", "New Delhi", "CUET (UG)", "http://keshav.du.ac.in/"),
      c(16, "Symbiosis Centre for Management Studies", "Noida", "SET", "https://www.scmsnoida.ac.in/"),
      c(17, "Bharati Vidyapeeth", "Pune", "BVP-CET", "https://bvuniversity.edu.in/"),
      c(18, "Centre for Management Studies, Jain University", "Bangalore", "JET", "https://www.cms.ac.in/"),
      c(19, "MSU", "Baroda", "MSU-ET", "https://www.msubaroda.ac.in/"),
      c(20, "SRM Institute of Science and Commerce", "Chennai", "Based on 12th Marks", "http://www.srmuniv.ac.in/"),
      c(1, "IIM Indore", "Indore", "IPMAT + WAT & PI", "https://www.iimidr.ac.in/", "5-Year Integrated"),
      c(2, "IIM Rohtak", "Rohtak", "IPM-AT", "https://www.iimrohtak.ac.in/", "5-Year Integrated"),
      c(3, "IIM Ranchi", "Ranchi", "IPM-AT", "https://iimranchi.ac.in/", "5-Year Integrated"),
      c(4, "IIM Jammu", "Jammu", "IPM-AT", "http://www.iimj.ac.in/", "5-Year Integrated"),
      c(5, "IIM Bodh Gaya", "Bodh Gaya", "IPM-AT", "https://iimbg.ac.in/", "5-Year Integrated"),
      c(6, "Nirma University", "Ahmedabad", "Based on 10+2 Marks", "https://management.nirmauni.ac.in/", "5-Year Integrated"),
      c(7, "Amity University", "Noida", "Based on 12th Marks", "https://www.amity.edu/", "5-Year Integrated"),
      c(8, "NMIMS University", "Mumbai", "Written Test / GD / PI", "https://www.nmims.edu/", "5-Year Integrated"),
      c(9, "Manipal Academy of Higher Education", "Karnataka", "Merit", "https://manipal.edu/", "5-Year Integrated"),
      c(10, "Mody University of Science & Technology", "Sikar", "CET", "https://www.modyuniversity.ac.in/", "5-Year Integrated"),
      c(11, "KS School of Business Management", "Ahmedabad", "Based on 12th Marks", "https://ksschool.org.in/", "5-Year Integrated"),
      c(12, "IIPS DAVV", "Indore", "Based on 12th Marks", "http://iips.edu.in/", "5-Year Integrated"),
      c(13, "Ahmedabad University", "Ahmedabad", "Based on 10+2 Marks", "https://ahduni.edu.in/", "5-Year Integrated"),
      c(14, "University of Lucknow", "Lucknow", "LU Test", "https://www.lkouniv.ac.in/", "5-Year Integrated"),
      c(15, "UPES", "Dehradun", "Personal Interview", "https://www.upes.ac.in/", "5-Year Integrated"),
    ],
  },
  {
    slug: "commerce-finance",
    name: "Commerce and Finance",
    category: "Commerce",
    icon: "TrendingUp",
    comingSoon: false,
    overview:
      "Commerce (from Latin 'commercium' — trade) is the system of companies maximizing profit by offering products and services. Today it extends well beyond buying and selling to the exchange of data, information, intellectual property and more, largely facilitated by the internet.",
    degrees: [
      { name: "B.Com (Bachelor of Commerce)", duration: "3 Years", eligibility: "10+2 any stream" },
      { name: "B.Com (Hons.)", duration: "3/4 Years", eligibility: "10+2 any stream" },
      { name: "BBA (Finance)", duration: "3 Years", eligibility: "10+2 any stream" },
      { name: "BBA (Hons.) Finance", duration: "3/4 Years", eligibility: "10+2 any stream" },
      { name: "B.Sc. Finance", duration: "3 Years", eligibility: "10+2 any stream (Maths may be required)" },
      { name: "B.Sc. (Hons.) Finance", duration: "3/4 Years", eligibility: "10+2 any stream (Maths may be required)" },
    ],
    specializations: [
      "CA (Chartered Accountant)", "CS (Company Secretary)", "CWA (Cost & Works Accountant)",
      "CFA (Certified Finance Analyst)", "CFP (Certified Financial Planner)", "CCRA (Credit Research Analyst)",
      "Certified Alternative Investment Manager", "Certified Investment Research Analyst", "CSB (Certified Stock Broker)",
      "CIA (Certified Investment Analyst)", "Certified Actuary", "NSE Certifications", "BSE Certifications",
    ],
    careers: [
      "Higher Studies in Economics", "Finance & Accounting Jobs", "Indian Civil Services",
      "Own Venture in Financial Services", "CA / CS Certifications", "Stock Broking", "Banking / Insurance",
      "Taxation & Financial Planning Consulting", "Higher Studies in Commerce/Finance", "Practice in Company Laws",
      "Merchant Navy", "Indian Armed Forces", "Research and Academics", "Indian Audit & Accounts Services",
      "Higher Studies in Management",
    ],
    exams: [
      { name: "CUET (UG)", url: "https://cuet.samarth.ac.in/" },
      { name: "NMIMS-NPAT", url: "https://nmimsnpat.in/" },
      { name: "CUET (Christ University)", url: "https://christuniversity.in/" },
      { name: "B.Com-CET (IPU)", url: "http://www.ipu.ac.in/" },
      { name: "JMI-ET", url: "https://www.jmi.ac.in/" },
      { name: "MSU-ET", url: "https://admission.msubaroda.ac.in/" },
      { name: "BHU-UET", url: "https://www.bhu.ac.in/" },
      { name: "UG-JET (Jain)", url: "https://www.jainuniversity.ac.in/" },
      { name: "SSSIHL-UGT", url: "https://www.sssihl.edu.in/" },
      { name: "JSAT (Jindal)", url: "https://jgu.edu.in/" },
      { name: "AMU-ET", url: "https://www.amu.ac.in/" },
      { name: "MITWPU-UGPET", url: "https://mitwpu.edu.in/" },
    ],
    colleges: [
      c(1, "Sri Ram College of Commerce (SRCC)", "Delhi", "CUET (UG)", "https://www.srcc.edu/"),
      c(2, "Lady Shri Ram College for Women (LSR)", "Delhi", "CUET (UG)", "http://www.lsr.edu.in/"),
      c(3, "Hansraj College", "Delhi", "CUET (UG)", "https://www.hansrajcollege.ac.in/"),
      c(4, "Madras Christian College (MCC)", "Chennai", "Based on 12th Marks", "https://www.mcc.edu.in/"),
      c(5, "Jamia Millia Islamia", "New Delhi", "JMI-ET / CUET (UG)", "https://www.jmi.ac.in/"),
      c(6, "Banaras Hindu University", "Varanasi", "BHU-UET / CUET (UG)", "https://www.bhu.ac.in/"),
      c(7, "Narsee Monjee (NMIMS)", "Mumbai", "NPAT", "https://www.nmims.edu/"),
      c(8, "Dept. of Commerce, Christ University", "Bengaluru", "CUET", "https://christuniversity.in/"),
      c(9, "Hindu College", "Delhi", "CUET (UG)", "http://www.hinducollege.ac.in/"),
      c(10, "Ramjas College", "Delhi", "CUET (UG)", "http://ramjas.du.ac.in/"),
      c(11, "Mithibai College", "Mumbai", "Based on 12th Marks", "http://mithibai.ac.in/"),
      c(12, "Stella Maris College", "Chennai", "Based on 12th Marks", "http://stellamariscollege.edu.in/"),
      c(13, "Deen Dayal Upadhyaya College", "New Delhi", "CUET (UG)", "https://dducollegedu.ac.in/"),
      c(14, "Indraprastha College for Women", "Delhi", "CUET (UG)", "http://www.ipcollege.ac.in/"),
      c(15, "Loyola College", "Chennai", "Based on 12th Marks", "http://www.loyolacollege.edu/"),
      c(16, "St. Joseph's College of Commerce", "Bangalore", "Based on 12th Marks", "https://www.sjcc.edu.in/"),
      c(17, "Atma Ram Sanatan Dharma College", "New Delhi", "CUET (UG)", "https://www.arsdcollege.ac.in/"),
      c(18, "Daulat Ram College", "New Delhi", "CUET (UG)", "http://www.dr.du.ac.in/index.php"),
      c(19, "Kristu Jayanti College", "Bangalore", "Based on 12th Marks", "https://kristujayanti.edu.in/"),
      c(20, "K.J. Somaiya College of Arts and Commerce", "Mumbai", "Based on 12th Marks", "https://simsr.somaiya.edu/"),
      c(21, "Goenka College of Commerce & Bus. Adm.", "Kolkata", "Based on 12th Marks", "http://goenkacollege.net/"),
      c(22, "Goswami Ganesh Dutt S.D. College", "Chandigarh", "Based on 12th Marks", "http://ggdsd.ac.in/"),
      c(23, "Mount Carmel College", "Bangalore", "Based on 12th Marks", "https://mccblr.edu.in/"),
      c(24, "Gargi College", "Delhi", "CUET (UG)", "https://gargicollege.in/"),
      c(25, "Kishinchand Chellaram College", "Mumbai", "Based on 12th Marks", "https://www.kccollege.edu.in/"),
      c(26, "Sri Guru Gobind Singh College of Commerce", "New Delhi", "CUET (UG)", "https://www.sggscc.ac.in/"),
      c(27, "Delhi College of Arts & Commerce (DCAC)", "Delhi", "CUET (UG)", "http://dcac.du.ac.in/index.php"),
      c(28, "Symbiosis College of Arts and Commerce", "Pune", "Based on 12th Marks", "https://www.symbiosiscollege.edu.in/"),
      c(29, "Women's Christian College", "Chennai", "Based on 12th Marks", "https://wcc.edu.in/"),
      c(30, "Shivaji College", "New Delhi", "CUET (UG)", "https://www.shivajicollege.ac.in/"),
      c(31, "Vimala College (Autonomous)", "Thrissur", "Based on 12th Marks", "http://vimalacollege.edu.in/"),
      c(32, "Sacred Heart College", "Kochi", "Based on 12th Marks", "http://www.shcollege.ac.in/"),
      c(33, "Maharaja Agrasen College", "New Delhi", "CUET (UG)", "http://mac.du.ac.in/"),
      c(34, "Maitreyi College", "New Delhi", "CUET (UG)", "http://maitreyi.ac.in/default.aspx"),
      c(35, "JD Birla Institute", "Kolkata", "Based on 12th Marks", "https://www.jdbikolkata.in/"),
      c(36, "B.K. Birla College (Autonomous)", "Kalyan", "Based on 12th Marks", "https://www.bkbirlacollegekalyan.com/"),
      c(37, "Ness Wadia College of Commerce", "Pune", "Based on 12th Marks", "https://nesswadiacollege.edu.in/"),
      c(38, "Ethiraj College for Women (Autonomous)", "Chennai", "Based on 12th Marks", "https://www.ethirajcollege.edu.in/"),
      c(39, "St. Xavier's College", "Ranchi", "Based on 12th Marks", "https://www.sxcran.org/"),
      c(40, "Seshadripuram College", "Bengaluru", "Based on 12th Marks", "https://www.spmcollege.ac.in/"),
      c(41, "Isabella Thoburn College", "Lucknow", "Based on 12th Marks", "http://itcollege.ac.in/itdc/"),
      c(42, "St. Francis College for Women", "Hyderabad", "Based on 12th Marks", "https://sfc.ac.in/"),
      c(43, "Ramanujan College", "New Delhi", "CUET (UG)", "https://ramanujancollege.ac.in/"),
      c(44, "Lakshmibai College", "New Delhi", "CUET (UG)", "https://lakshmibaicollege.in/"),
      c(45, "Bharati College", "New Delhi", "CUET (UG)", "https://www.bharaticollege.org/"),
      c(46, "Mehr Chand Mahajan DAV College for Women", "Chandigarh", "Based on 12th Marks", "https://mcmdavcwchd.edu.in/"),
      c(47, "PG Government College for Girls", "Chandigarh", "Based on 12th Marks", "http://www.gcg11.ac.in/"),
      c(48, "DAV College", "Chandigarh", "Based on 12th Marks", "https://davchd.ac.in/"),
      c(49, "St. Mira's College for Girls", "Pune", "Based on 12th Marks", "https://www.stmirascollegepune.edu.in/"),
      c(50, "St. Ann's College for Women", "Hyderabad", "Based on 12th Marks", "https://www.stannscollegehyd.com/"),
    ],
  },
  {
    slug: "computer-applications-sciences",
    name: "Computer Applications and Sciences",
    category: "Technology",
    icon: "Cpu",
    comingSoon: false,
    overview:
      "This vertical (distinct from Computer Engineering) covers the application of computing to solve real-world problems — software, applications, databases, networking and emerging tech. Graduates build, manage and analyze systems across virtually every industry.",
    degrees: [
      { name: "BCA (Bachelor of Computer Applications)", duration: "3 Years", eligibility: "10+2 any stream" },
      { name: "B.Com (CS) — with Computer Science", duration: "3 Years", eligibility: "10+2 any stream" },
      { name: "B.Sc. (CS) — Computer Science", duration: "3 Years", eligibility: "10+2 any stream" },
      { name: "B.Sc. (IT) — Information Technology", duration: "3 Years", eligibility: "10+2 any stream" },
      { name: "BBA-IT", duration: "3 Years", eligibility: "10+2 any stream" },
      { name: "BCA + MCA (Integrated)", duration: "5 Years", eligibility: "10+2 any stream" },
      { name: "B.Sc. + M.Sc. (IT) (Integrated)", duration: "5 Years", eligibility: "10+2 any stream" },
    ],
    specializations: [
      "Artificial Intelligence", "Cloud Computing", "Automation", "Cryptography", "Blockchain",
      "Machine Learning", "Internet of Things (IoT)", "Networking", "Game Design", "Cyber Security",
      "Ethical Hacking", "Information Management Systems", "Digital Marketing", "UI/UX", "SEO/SEM",
      "Data Science", "Robotics", "Animation & VFX", "Business Analytics", "Fintech",
      "Computer Science", "Software / Web / App Development",
    ],
    careers: [
      "Teaching (School/University)", "Application Development", "Indian Civil Services", "Web Designing",
      "Corporate Jobs", "Networking & System Analyst", "Merchant Navy", "e-Commerce & Marketing",
      "Start own IT Venture", "Higher Studies", "Systems Management", "Database Systems",
      "Quality Assurance Analyst", "Central Research Organizations", "Banking Sector", "Multimedia & Animation",
    ],
    exams: [
      { name: "CUET (UG)", url: "https://cuet.samarth.ac.in/" },
      { name: "SET-General (Symbiosis)", url: "https://www.set-test.org/" },
      { name: "CUET (Christ University)", url: "https://christuniversity.in/" },
      { name: "UGAT", url: "https://apps.aima.in/" },
      { name: "BU-MAT", url: "https://bvuniversity.edu.in/" },
      { name: "SSSIHL-UGT", url: "https://www.sssihl.edu.in/" },
      { name: "UG-JET (Jain)", url: "https://www.jainuniversity.ac.in/" },
      { name: "KIIT-EE", url: "https://kiit.ac.in/" },
      { name: "AMU-ET", url: "https://www.amu.ac.in/" },
      { name: "BCA-CET (IPU)", url: "http://www.ipu.ac.in/" },
      { name: "MITWPU-UGPET", url: "https://mitwpu.edu.in/" },
      { name: "KUAT (Karnavati)", url: "https://karnavatiuniversity.edu.in/" },
    ],
    colleges: [
      c(1, "University of Madras", "Chennai", "Based on 12th Marks", "https://www.unom.ac.in/"),
      c(2, "University of Lucknow", "Uttar Pradesh", "Based on 12th Marks", "https://www.lkouniv.ac.in/en"),
      c(3, "Jamia Hamdard University", "Delhi", "CUET (UG)", "http://jamiahamdard.edu/"),
      c(4, "Punjabi University", "Patiala", "Based on 12th Marks", "http://www.punjabiuniversity.ac.in/"),
      c(5, "Sri Sathya Sai Institute of Higher Learning", "Andhra Pradesh", "SSSIHL-UG Test", "https://www.sssihl.edu.in/"),
      c(6, "Gujarat University", "Ahmedabad", "Based on 12th Marks", "https://www.gujaratuniversity.ac.in/"),
      c(7, "MS University", "Baroda", "Own Test", "https://www.msubaroda.ac.in/"),
      c(8, "Rajasthan University", "Jaipur", "Based on 12th Marks", "https://www.uniraj.ac.in/"),
      c(9, "Jiwaji University", "Gwalior", "JUET", "http://www.jiwaji.edu/"),
      c(10, "Vikram University", "Ujjain", "Based on 12th Marks", "http://www.vikramuniv.ac.in/"),
      c(11, "Banasthali University", "Vanasthali", "Based on 12th Marks", "http://www.banasthali.org/"),
      c(12, "Kalasalingam University", "Tamil Nadu", "Based on 12th Marks", "https://kalasalingam.ac.in/"),
      c(13, "Symbiosis International University", "Pune", "SET", "https://siu.edu.in/"),
      c(14, "Christ University", "Bengaluru", "CUET", "https://christuniversity.in/"),
      c(15, "Mohanlal Sukhadia University", "Udaipur", "Based on 12th Marks", "https://www.mlsu.ac.in/"),
      c(16, "Indraprastha University (IPU)", "Delhi", "BCA-CET", "http://www.ipu.ac.in/"),
      c(17, "Bharati Vidyapeeth", "Pune", "B-UMAT", "https://bvuniversity.edu.in/"),
      c(18, "Guru Nanak Dev University", "Amritsar", "CET", "https://online.gndu.ac.in/"),
      c(19, "MCN University", "Bhopal", "Based on 12th Marks", "https://www.mcu.ac.in/"),
      c(20, "Ahmedabad University", "Ahmedabad", "Based on 12th Marks", "https://ahduni.edu.in/"),
      c(21, "Dharmsinh Desai University", "Nadiad", "Based on 12th Marks", "https://www.ddu.ac.in/"),
      c(22, "DRMLA University", "Ayodhya", "Based on 12th Marks", "http://www.rmlau.ac.in/"),
      c(23, "Periyar Maniammai IST University", "Thanjavur", "Based on 12th Marks", "https://pmu.edu/"),
      c(24, "Vellore Institute of Technology", "Vellore", "Based on 12th Marks (Maths)", "https://vit.ac.in/"),
      c(25, "SRM University", "Kattankulathur", "Based on 12th Marks (Maths)", "https://www.srmist.edu.in/"),
      c(26, "The IIS University", "Jaipur", "Based on 12th Marks", "https://www.iisuniv.ac.in/"),
      c(27, "Sikkim Manipal University", "Sikkim", "Based on 12th Marks", "https://smu.edu.in/"),
      c(28, "Sri C.S. Saraswathi University", "Enathur", "Based on 12th Marks", "https://kanchiuniv.ac.in/"),
      c(29, "CSJM University", "Kanpur", "Based on 12th Marks", "http://csjmu.ac.in/"),
      c(30, "Devi Ahilya Vishwavidyalaya", "Indore", "Based on 12th Marks (Maths)", "https://www.dauniv.ac.in/"),
      c(31, "Pacific University", "Udaipur", "Based on 12th Marks", "https://www.pacific-university.ac.in/"),
      c(32, "Osmania University", "Hyderabad", "Based on 12th Marks", "https://www.osmania.ac.in/"),
      c(33, "M.M.H. Arabic & Persian University", "Patna", "Based on 12th Marks", "https://mmhapu.ac.in/"),
      c(34, "Dr. CV Raman University", "Bilaspur", "Based on 12th Marks", "https://www.cvru.ac.in/"),
      c(35, "Dr. Harisingh Gour University", "Sagar", "Based on 12th Marks", "http://www.dhsgsu.ac.in/"),
      c(36, "M.M. Yogi Vedic", "Katni", "Based on 12th Marks", "http://www.mmyvv.com/"),
      c(37, "KAHE University", "Coimbatore", "Based on 12th Marks", "https://kahedu.edu.in/"),
      c(38, "Tilak Maharashtra University", "Pune", "Based on 12th Marks (Maths)", "http://www.tmv.edu.in/"),
      c(39, "Shri Ramswaroop Memorial University", "Barabanki", "Based on 12th Marks", "https://www.srmu.ac.in/"),
      c(40, "Ganpat University", "Kherva", "Based on 12th Marks", "https://www.ganpatuniversity.ac.in/"),
      c(41, "C.U. Shah University", "Surendranagar", "Based on 12th Marks", "https://www.cushahuniversity.ac.in/"),
      c(42, "Maharishi Markandeshwar University", "Mullana", "Based on 12th Marks", "https://www.mmumullana.org/"),
      c(43, "Uka Tarsadia University", "Bardoli", "Based on 12th Marks", "http://www.utu.ac.in/"),
    ],
  },
  {
    slug: "defence-forces-nda",
    name: "Defence Forces (NDA)",
    category: "Defence",
    icon: "Shield",
    comingSoon: false,
    overview:
      "The NDA & Naval Academy Examination (conducted by UPSC) is the pathway to join the Indian Army, Navy and Air Force. After a written test, SSB interview and fitness evaluation, cadets complete a 3-year course (degree from IGNOU), then specialized pre-commission training at IMA, INA or AFA, and are commissioned as officers.",
    degrees: [
      { name: "B.A. (Bachelor of Arts)", duration: "3 Years", eligibility: "10+2 any stream" },
      { name: "B.Sc. (Bachelor of Science)", duration: "3 Years", eligibility: "10+2 with PCM/B" },
      { name: "B.E. (Bachelor of Engineering)", duration: "4 Years", eligibility: "10+2 with PCM" },
    ],
    specializations: ["The Army", "The Navy", "The Air Force"],
    careers: [
      "Army: Lieutenant → Captain → Major → Lt. Colonel → Colonel → Brigadier → Major General → Lt. General → General",
      "Navy: Sub Lieutenant → Lieutenant → Lieutenant Commander → Commander → Captain → Commodore → Rear-Admiral → Vice-Admiral → Admiral",
      "Air Force: Flying Officer → Flight Lieutenant → Squadron Leader → Wing Commander → Group Captain → Air Commodore → Air Vice Marshal → Air Marshal → Air Chief Marshal",
    ],
    exams: [{ name: "NDA & NA Examination (UPSC)", url: "https://www.upsc.gov.in/" }],
    colleges: [
      c(1, "National Defence Academy (NDA)", "Khadakwasla, Pune", "NDA & NA Exam (UPSC) + SSB + Medical", "https://www.upsc.gov.in/"),
      c(2, "Indian Military Academy (IMA)", "Dehradun", "Post-NDA (Army cadets)", "https://indianarmy.nic.in/"),
      c(3, "Indian Naval Academy (INA)", "Ezhimala, Kerala", "Post-NDA (Naval cadets)", "https://www.joinindiannavy.gov.in/"),
      c(4, "Air Force Academy (AFA)", "Hyderabad", "Post-NDA (Air Force cadets)", "https://indianairforce.nic.in/"),
    ],
  },
  {
    slug: "design-fine-arts",
    name: "Design and Fine Arts",
    category: "Design",
    icon: "Palette",
    comingSoon: false,
    overview:
      "Design education spans graphic, UI, web, packaging, industrial, fashion, information, interior and sustainable design. At its core it is problem-solving — equipping individuals with practical methods, knowledge and talent to tackle new challenges, with each school emphasizing distinct values.",
    degrees: [
      { name: "BFA (Bachelor of Fine Arts)", duration: "4 Years", eligibility: "10+2 any stream" },
      { name: "BVA (Bachelor of Visual Arts)", duration: "4 Years", eligibility: "10+2 any stream" },
      { name: "BID (Bachelor of Interior Design)", duration: "4 Years", eligibility: "10+2 any stream / with Maths" },
      { name: "B.Des (Bachelor of Design)", duration: "4 Years", eligibility: "10+2 any stream" },
      { name: "BA / BA (Hons) — various", duration: "3/4 Years", eligibility: "10+2 any stream" },
      { name: "B.Sc / B.Voc — various", duration: "3/4 Years", eligibility: "10+2 any stream / with Maths" },
      { name: "B.F.Tech (Bachelor of Fashion Technology)", duration: "4 Years", eligibility: "10+2 with PCM" },
      { name: "BBA (Fashion Management)", duration: "3 Years", eligibility: "10+2 any stream" },
    ],
    specializations: [
      "3D", "Automobile", "Environmental Design", "Fashion Styling & Image Design", "Furniture", "Interior",
      "Lifestyle Accessory", "Retail & Interior Space Design", "Toy", "Visual Arts", "Animation", "Ceramic",
      "Exhibition", "Fashion Technology", "Game", "Jewellery & Metal Smithing", "Photography", "Sculptures",
      "Transdisciplinary Design", "Visual Communication", "Apparel", "Communication & Media Design", "Fashion",
      "Fine Arts", "Graphic", "Knitwear", "Pottery & Ceramics", "Strategic Innovation & Design",
      "User Interaction & Experience Design", "Web", "Applied Arts", "Drawing & Painting", "Fashion Communication",
      "Footwear Design", "Industrial", "Leather", "Product", "Textile", "VFX", "Wood",
    ],
    careers: [
      "Higher Studies", "Government Organizations", "Indian Armed Forces",
      "Own Venture / Exhibitions / Galleries / Studios", "Media & Public Relations / Production House",
      "Higher Studies in Management", "Television and Art Industry", "Advertising / Event Management / Creative Writing",
      "Magazine / Newspaper / Publishing / Textile Industry", "Corporate Jobs / Civil Services / Fashion Industry",
    ],
    exams: [
      { name: "DAT Prelims & Mains (NID)", url: "https://www.nid.edu/" },
      { name: "UCEED (IIT Bombay)", url: "http://www.uceed.iitb.ac.in/" },
      { name: "FDDI ET", url: "https://www.fddiindia.com/" },
      { name: "GAT & CAT (NIFT)", url: "https://nift.ac.in/" },
      { name: "SMEAT-UG (Srishti Manipal)", url: "http://srishtimanipalinstitute.in/" },
      { name: "SEED (Symbiosis)", url: "https://www.set-test.org/" },
      { name: "NIIFT-ET", url: "http://www.niiftindia.com/" },
      { name: "MH AAC CET", url: "http://cetcell.mahacet.org/" },
      { name: "BHU-UET", url: "https://www.bhu.ac.in/" },
      { name: "UID-DAT (Karnavati)", url: "https://karnavatiuniversity.edu.in/" },
      { name: "MITID-DAT", url: "https://mitid.edu.in/" },
      { name: "IICD ET", url: "http://www.iicd.ac.in/" },
      { name: "IDAT (IIAD)", url: "https://www.iiad.edu.in/" },
      { name: "NMIMS-DAT", url: "https://nmimsdat.in/" },
      { name: "WWI-ET (Whistling Woods)", url: "https://www.whistlingwoods.net/" },
      { name: "UPESDAT", url: "https://www.upes.ac.in/" },
      { name: "MITWPU-UG DAT", url: "https://mitwpu.edu.in/" },
    ],
    colleges: [
      c(1, "National Institute of Design (NID)", "Ahmedabad", "DAT Prelims & Mains", "https://www.nid.edu/"),
      c(2, "IDC School of Design, IIT Bombay", "Mumbai", "UCEED", "http://www.idc.iitb.ac.in/"),
      c(3, "NIFT", "New Delhi", "GAT & CAT", "https://www.nift.ac.in/delhi/"),
      c(4, "NIFT", "Chennai", "GAT & CAT", "https://www.nift.ac.in/chennai/"),
      c(5, "Department of Design, IIT Guwahati", "Guwahati", "UCEED", "https://www.iitg.ac.in/design/"),
      c(6, "NIFT", "Bengaluru", "GAT & CAT", "https://www.nift.ac.in/bengaluru/"),
      c(7, "NIFT", "Hyderabad", "GAT & CAT", "https://www.nift.ac.in/hyderabad/"),
      c(8, "NIFT", "Gandhinagar", "GAT & CAT", "https://www.nift.ac.in/gandhinagar/"),
      c(9, "Banaras Hindu University", "Varanasi", "BHU-UET", "https://www.bhu.ac.in/"),
      c(10, "Footwear Design & Development Institute", "Noida", "FDDI EE", "https://fddiindia.com/campus-noida.php"),
      c(11, "CEPT University", "Ahmedabad", "Aptitude Test", "https://cept.ac.in/"),
      c(12, "Government College of Art and Craft", "Calcutta", "Aptitude Test", "https://www.gcac.edu.in/"),
      c(13, "University of Allahabad", "Prayagraj", "Entrance & Practical Test", "https://www.allduniv.ac.in/"),
      c(14, "NIFT", "Kolkata", "GAT & CAT", "https://www.nift.ac.in/kolkata/"),
      c(15, "NIFT", "Navi Mumbai", "GAT & CAT", "https://www.nift.ac.in/mumbai"),
      c(16, "NIFT", "Patna", "GAT & CAT", "https://www.nift.ac.in/patna/"),
      c(17, "NIFT", "Raebareli", "GAT & CAT", "https://www.nift.ac.in/raebareli/"),
      c(18, "NIFT", "Bhopal", "GAT & CAT", "https://nift.ac.in/bhopal/"),
      c(19, "NIFT", "Kannur", "GAT & CAT", "https://www.nift.ac.in/kannur/"),
      c(20, "NIFT", "Shillong", "GAT & CAT", "https://www.nift.ac.in/shillong/"),
      c(21, "NIFT", "Kangra", "GAT & CAT", "https://www.nift.ac.in/kangra/"),
      c(22, "NIFT", "Bhubaneshwar", "GAT & CAT", "https://nift.ac.in/bhubaneswar/"),
      c(23, "NIFT", "Jodhpur", "GAT & CAT", "https://www.nift.ac.in/jodhpur/"),
      c(24, "FDDI", "Fursatganj", "FDDI EE", "https://fddiindia.com/campus-fursatganj.php"),
      c(25, "FDDI", "Chennai", "FDDI EE", "https://fddiindia.com/campus-chennai.php"),
      c(26, "FDDI", "Jodhpur", "FDDI EE", "https://fddiindia.com/campus-jodhpur.php"),
      c(27, "FDDI", "Chhindwara", "FDDI EE", "https://fddiindia.com/campus-chhindwara.php"),
      c(28, "M.S. University", "Baroda", "ET & PI", "https://www.msubaroda.ac.in/"),
      c(29, "FDDI", "Kolkata", "FDDI EE", "https://fddiindia.com/campus-kolkatta.php"),
      c(30, "FDDI", "Rohtak", "FDDI EE", "https://fddiindia.com/campus-rohtak.php"),
      c(31, "FDDI", "Ankleshwar", "FDDI EE", "https://fddiindia.com/campus-ankleshwar.php"),
      c(32, "FDDI", "Chandigarh", "FDDI EE", "https://fddiindia.com/campus-chandigarh.php"),
      c(33, "NIFT", "Srinagar", "GAT & CAT", "https://www.nift.ac.in/srinagar/"),
      c(34, "Unitedworld Institute of Design, Karnavati University", "Gandhinagar", "UID-DAT", "https://karnavatiuniversity.edu.in/uid/"),
      c(35, "FDDI", "Guna", "FDDI EE", "https://fddiindia.com/campus-guna.php"),
      c(36, "FDDI", "Hyderabad", "FDDI EE", "https://fddiindia.com/campus-hyderabad.php"),
      c(37, "FDDI", "Patna", "FDDI EE", "https://fddiindia.com/campus-patna.php"),
      c(38, "MKSSS's School of Fashion Technology", "Pune", "SOFT CET", "https://soft.ac.in/"),
      c(39, "Manipal University (Faculty of Architecture)", "Manipal", "MET & DT", "https://manipal.edu/foa.html"),
      c(40, "Banasthali Vidyapith", "Vanasthali", "Based on 12th", "http://www.banasthali.org/"),
      c(41, "Northern India Institute of Fashion Technology", "Mohali", "NIIFT-ET", "http://www.niiftindia.com/"),
      c(42, "SNDT Women's University", "Mumbai", "Based on 12th", "https://sndt.ac.in/"),
      c(43, "Srishti Institute of Art, Design and Technology", "Bangalore", "SEAT", "http://srishtimanipalinstitute.in/"),
      c(44, "Indian Institute of Crafts and Design", "Jaipur", "IICD ET & PI", "https://www.iicd.ac.in/en/"),
      c(45, "MIT", "Pune", "MITID-DAT", "https://mitwpu.edu.in/"),
      c(46, "Symbiosis Institute of Design", "Pune", "SEED", "https://www.sid.edu.in/"),
      c(47, "Amity University", "Noida", "Creative Test", "https://www.amity.edu/asfa/"),
      c(48, "Army Institute of Fashion and Design", "Bengaluru", "CBT", "https://aifd.edu.in/"),
      c(49, "Nirma University", "Ahmedabad", "UCEED + Situation Test & PI", "https://nirmauni.ac.in/"),
      c(50, "J.D. Birla Institute", "Kolkata", "Based on 12th", "https://www.jdbikolkata.in/"),
      c(1, "Department of Design, IIT Delhi", "New Delhi", "UCEED", "https://design.iitd.ac.in/", "New 2021"),
      c(2, "Department of Design, IIT Hyderabad", "Hyderabad", "UCEED", "https://design.iith.ac.in/", "New 2021"),
      c(3, "Design Discipline, IIITDM Jabalpur", "Jabalpur", "UCEED", "https://www.iiitdmj.ac.in/", "New 2021"),
      c(4, "National Institute of Design", "Andhra Pradesh", "DAT Prelims & Mains", "https://nidap.ac.in/", "New 2021"),
      c(5, "National Institute of Design", "Bhopal", "DAT Prelims & Mains", "https://nidmp.ac.in/", "New 2021"),
      c(6, "National Institute of Design", "Jorhat", "DAT Prelims & Mains", "https://www.nidj.ac.in/", "New 2021"),
      c(7, "National Institute of Design", "Kurukshetra", "DAT Prelims & Mains", "https://www.nidh.ac.in/", "New 2021"),
    ],
  },
  {
    slug: "economics",
    name: "Economics",
    category: "Social Sciences",
    icon: "LineChart",
    comingSoon: false,
    overview:
      "Economics studies the behavior and interactions of economic agents and how economies work. Microeconomics analyzes individual agents and markets; macroeconomics analyzes the whole economy — production, consumption, savings, investment, inflation, growth and public policy. Economists research data, monitor trends and forecast outcomes.",
    degrees: [
      { name: "BA (Bachelor of Arts)", duration: "3 Years", eligibility: "10+2 any stream" },
      { name: "BA (Hons.)", duration: "3/4 Years", eligibility: "10+2 any stream" },
      { name: "B.Sc. (with Economics)", duration: "3/4 Years", eligibility: "10+2 with Maths/Stats/Business Maths" },
      { name: "B.Sc. (Hons.) (with Economics)", duration: "3/4 Years", eligibility: "10+2 with Maths/Stats/Business Maths" },
    ],
    specializations: [
      "Applied Economic Research", "Public Finance & Policy", "International Monetary Economics",
      "Economic Consultancy", "Data Analytics", "Economic Journalism", "Banking", "Research & Academics",
    ],
    careers: [
      "Multinational Trading Corporations", "Import Export Houses", "Government/Private Sector Banks",
      "Economic Journalism", "Applied Economic Research", "Public Finance & Policy", "Indian Armed Forces",
      "Economics Consultant", "NCAER", "International Monetary Fund", "National Institute of Public Finance & Policy",
      "Data Analytics", "NITI Aayog", "Indian Civil Services", "Research and Academics",
    ],
    exams: [
      { name: "CUET (UG)", url: "https://cuet.samarth.ac.in/" },
      { name: "BA-CET (IPU)", url: "http://www.ipu.ac.in/" },
      { name: "NMIMS-NPAT", url: "https://nmimsnpat.in/" },
      { name: "SET-General (Symbiosis)", url: "https://www.set-test.org/" },
      { name: "CUET (Christ University)", url: "https://christuniversity.in/" },
      { name: "AMU-ET", url: "https://www.amu.ac.in/" },
      { name: "AAT (Ashoka)", url: "https://www.ashoka.edu.in/" },
      { name: "BHU-UET", url: "https://www.bhu.ac.in/" },
      { name: "JMI-ET", url: "https://www.jmi.ac.in/" },
      { name: "KSOM-ET (KIIT)", url: "https://ksom.ac.in/" },
      { name: "UG-JET (Jain)", url: "https://www.jainuniversity.ac.in/" },
      { name: "SNUSAT + APT", url: "https://home.pearsonvue.com/snu" },
      { name: "SSSIHL-UGT", url: "https://www.sssihl.edu.in/" },
      { name: "JSAT (Jindal)", url: "https://jgu.edu.in/" },
      { name: "KIIT-EE", url: "https://kiit.ac.in/" },
      { name: "MITWPU-UGPET", url: "https://mitwpu.edu.in/" },
      { name: "APU-ET (Azim Premji)", url: "https://azimpremjiuniversity.edu.in/" },
    ],
    colleges: [
      c(1, "St. Stephen's College", "Delhi", "CUET (UG)", "https://www.ststephens.edu/"),
      c(2, "Shri Ram College of Commerce", "Delhi", "CUET (UG)", "https://www.srcc.edu/"),
      c(3, "Miranda House College for Women", "Delhi", "CUET (UG)", "https://www.mirandahouse.ac.in/"),
      c(4, "Hansraj College", "Delhi", "CUET (UG)", "https://www.hansrajcollege.ac.in/"),
      c(5, "Madras Christian College", "Chennai", "Based on 12th Marks", "http://mcc.edu.in/"),
      c(6, "Narsee Monjee (NMIMS)", "Mumbai", "NPAT", "https://www.nmims.edu/"),
      c(7, "Christ University", "Bangalore", "CUET", "https://christuniversity.in/"),
      c(8, "Loyola College", "Chennai", "Based on 12th Marks", "https://www.loyolacollege.edu/"),
      c(9, "Lady Shri Ram College", "Delhi", "Based on 12th Marks", "https://lsr.edu.in/"),
      c(10, "Ramjas College", "Delhi", "CUET (UG)", "https://ramjas.du.ac.in/"),
      c(11, "Stella Maris College", "Chennai", "Based on 12th Marks", "https://stellamariscollege.edu.in/"),
      c(12, "Gargi College", "Delhi", "CUET (UG)", "http://www.gargi.du.ac.in/"),
      c(13, "Hindu College", "Delhi", "CUET (UG)", "https://www.hinducollege.ac.in/"),
      c(14, "Kamala Nehru College", "Delhi", "CUET (UG)", "https://www.knc.edu.in/"),
      c(15, "Banaras Hindu University", "Varanasi", "BHU-UET / CUET (UG)", "https://www.bhu.ac.in/"),
      c(16, "Symbiosis School of Economics", "Pune", "SET", "https://sse.ac.in/"),
      c(17, "Fergusson College", "Pune", "Based on 12th Marks", "https://www.fergusson.edu/"),
      c(18, "Mithibai College", "Mumbai", "Based on 12th Marks", "https://www.mithibai.ac.in/"),
      c(19, "Maharaja Agrasen College", "Delhi", "CUET (UG)", "http://www.mac.du.ac.in/"),
      c(20, "Delhi Technical Campus, GGSIPU", "Greater Noida", "IP-CET", "https://delhitechnicalcampus.ac.in/"),
      c(21, "Delhi College of Arts & Commerce", "Delhi", "CUET (UG)", "http://dcac.du.ac.in/"),
      c(22, "Mount Carmel College", "Bangalore", "Based on 12th Marks", "https://mccblr.edu.in/"),
      c(23, "GGDSD College", "Chandigarh", "Based on 12th Marks", "http://ggdsd.ac.in/"),
      c(24, "St. Xavier's College", "Ahmedabad", "Based on 12th Marks", "https://sxca.edu.in/"),
      c(25, "Presidency University", "Kolkata", "Based on 12th Marks", "https://www.presiuniv.ac.in/web/"),
      c(26, "Aryabhatta College", "Delhi", "CUET (UG)", "https://aryabhattacollege.ac.in/"),
      c(27, "Lakshmibai College", "Delhi", "CUET (UG)", "https://lakshmibaicollege.in/"),
      c(28, "Jamia Millia Islamia", "Delhi", "JMI-ET / CUET (UG)", "https://www.jmi.ac.in/"),
      c(29, "Kristu Jayanti College", "Bangalore", "Based on 12th Marks", "https://kristujayanti.edu.in/"),
      c(30, "The Oxford College of Arts", "Bangalore", "Based on 12th Marks", "http://www.theoxford.edu/"),
      c(31, "Ethiraj College", "Chennai", "Based on 12th Marks", "https://ethirajcollege.edu.in/"),
      c(32, "Sacred Heart College, Thevara", "Kochi", "Based on 12th Marks", "https://www.shcollege.ac.in/"),
      c(33, "Aligarh Muslim University", "Aligarh", "AMU-EE / CUET (UG)", "https://www.amu.ac.in/"),
      c(34, "MSU", "Baroda", "Based on 12th Marks", "https://www.msubaroda.ac.in/"),
      c(35, "St. Francis College for Women", "Hyderabad", "Based on 12th Marks", "https://www.sfc.ac.in/"),
      c(36, "St. Teresa's College", "Kochi", "Based on 12th Marks", "https://teresas.ac.in/"),
      c(37, "Shivaji College", "Delhi", "CUET (UG)", "https://www.shivajicollege.ac.in/"),
      c(38, "Delhi Technological University", "Delhi", "Based on 12th Marks", "http://dtu.ac.in/"),
      c(39, "Vivekananda College", "Kolkata", "Based on 12th Marks", "https://www.vckolkata63.org/"),
      c(40, "Sri Guru Nanak Dev Khalsa College", "Delhi", "CUET (UG)", "https://www.sgndkc.org/"),
      c(41, "Jesus and Mary College", "Delhi", "CUET (UG)", "https://www.jmc.ac.in/"),
      c(42, "Maharaja Agrasen Inst. of Mgmt. Studies, GGSIPU", "Delhi", "IP-CET", "https://maims.ac.in/"),
      c(43, "St. Xavier's College", "Kolkata", "Based on 12th Marks", "https://www.sxccal.edu/"),
      c(44, "Bhim Rao Ambedkar College", "Delhi", "CUET (UG)", "https://www.drbrambedkarcollege.ac.in"),
      c(45, "Sri Guru Gobind College of Commerce", "Delhi", "CUET (UG)", "https://www.sggscc.ac.in/"),
      c(46, "Sri Guru Tegh Bahadur Khalsa College", "Delhi", "CUET (UG)", "https://sgtbkhalsadu.ac.in/"),
      c(47, "Ahmedabad University", "Ahmedabad", "Based on 12th Marks", "https://ahduni.edu.in/"),
      c(48, "Jagan Institute of Management Studies, GGSIPU", "Delhi", "IP-CET", "https://www.jimsindia.org/"),
      c(49, "Gokhale Institute of Politics and Economics", "Pune", "Based on 12th Marks", "http://gipe.ac.in/"),
      c(50, "Jain University", "Bangalore", "JET", "https://www.jainuniversity.ac.in/"),
    ],
  },
  {
    slug: "engineering-technology",
    name: "Engineering and Technology",
    category: "Engineering",
    icon: "Cog",
    comingSoon: false,
    overview:
      "Engineering and Technology applies scientific principles to design, build and maintain structures, machines, systems and processes. Spanning dozens of disciplines, it has driven human progress from the wheel to modern computing, and is fuelled by innovation, problem-solving and the pursuit of improving human life.",
    degrees: [
      { name: "B.Tech (Bachelor of Technology)", duration: "4 Years", eligibility: "10+2 with PCM" },
      { name: "B.E. (Bachelor of Engineering)", duration: "4 Years", eligibility: "10+2 with PCM" },
      { name: "B.S. (Bachelor of Science)", duration: "4 Years", eligibility: "10+2 with PCM" },
      { name: "B.F.Tech (Bachelor of Fashion Technology)", duration: "4 Years", eligibility: "10+2 with PCM" },
      { name: "B.Tech + M.Tech (Integrated)", duration: "5 Years", eligibility: "10+2 with PCM" },
      { name: "B.S. + M.S. (Integrated)", duration: "5 Years", eligibility: "10+2 with PCM" },
      { name: "Diploma + B.Tech (Integrated)", duration: "6 Years", eligibility: "10th Pass with 60%" },
    ],
    specializations: [
      "Aerospace", "Agricultural & Food", "Aeronautical", "Architecture", "Automobile", "Biochemical",
      "Biomedical", "Biological Sciences", "Biotechnology", "Ceramic", "Chemical", "Civil", "Computer Science",
      "Dairy Technology", "Electrical", "Electronics", "Electronics & Communication", "Electronics & Electrical",
      "Electronics & Instrumentation", "Engineering Physics", "Engineering Science", "Environmental",
      "Fire Technology", "Food & Nutrition", "Food Technology", "Genetic", "Geoinformatics",
      "Industrial & Systems", "Instrumentation", "Leather Technology", "Marine", "Material Science",
      "Mathematics & Computing", "Mechanical", "Mechatronics", "Metallurgical", "Mineral Resource", "Mining",
      "Mining Machinery", "Manufacturing Science", "Naval Architecture", "Ocean", "Petrochemical", "Petroleum",
      "Plastic", "Polymer", "Production", "Robotics", "Textile",
    ],
    careers: [
      "Higher Studies (Management/Technical)", "Own Business / Technical Venture", "Civil Services",
      "Research & Academics", "Banking Job", "Indian Engineering Services", "Indian Armed Forces",
      "Indian Railways", "Technical Company", "Merchant Navy", "Computer / IT Job", "Indian Civil Services",
    ],
    exams: [
      { name: "JEE Main", url: "http://www.jeemain.nta.nic.in/" },
      { name: "JEE Advanced", url: "https://www.jeeadv.ac.in/" },
      { name: "CUET (UG)", url: "https://cuet.samarth.ac.in/" },
      { name: "BITSAT", url: "https://www.bitsadmission.com/" },
      { name: "VITEEE", url: "https://viteee.vit.ac.in" },
      { name: "SRMJEEE (UG)", url: "https://www.srmist.edu.in/" },
      { name: "NMIMS-CET", url: "https://nmimscet.in/" },
      { name: "MET (Manipal)", url: "https://apply.manipal.edu/" },
      { name: "MHT-CET", url: "http://cetcell.mahacet.org" },
      { name: "KEA-CET", url: "https://cetonline.karnataka.gov.in/kea/" },
      { name: "KIIT-EE", url: "https://kiit.ac.in/" },
      { name: "AP-EAPCET", url: "https://sche.ap.gov.in/EAPCET" },
      { name: "WBJEE", url: "https://wbjeeb.in/" },
      { name: "UPESEAT", url: "https://www.upes.ac.in/" },
      { name: "CET Engineering (BVP)", url: "https://bvuniversity.edu.in/" },
      { name: "TS-EAMCET", url: "https://eamcet.tsche.ac.in/" },
      { name: "GAT (NIFT B.F.Tech)", url: "https://nift.ac.in/" },
      { name: "GUJCET", url: "http://gujcet.gseb.org/" },
      { name: "B.Tech CET (IPU)", url: "http://www.ipu.ac.in/" },
      { name: "CUET (Christ University)", url: "https://christuniversity.in/" },
      { name: "AMU-ET", url: "https://www.amu.ac.in/" },
    ],
    colleges: [
      c(1, "IIT Bombay", "Maharashtra", "JEE Advanced", "https://www.iitb.ac.in/"),
      c(2, "IIT Delhi", "Delhi", "JEE Advanced", "https://home.iitd.ac.in/"),
      c(3, "IIT Kanpur", "Uttar Pradesh", "JEE Advanced", "https://www.iitk.ac.in/"),
      c(4, "IIT Kharagpur", "West Bengal", "JEE Advanced", "http://www.iitkgp.ac.in/"),
      c(5, "IIT Madras", "Tamil Nadu", "JEE Advanced", "https://www.iitm.ac.in/"),
      c(6, "IIT Roorkee", "Uttarakhand", "JEE Advanced", "http://www.iitr.ernet.in/"),
      c(7, "IIT (BHU) Varanasi", "Uttar Pradesh", "JEE Advanced", "https://iitbhu.ac.in/"),
      c(8, "BITS Pilani", "Rajasthan", "BITSAT", "https://www.bits-pilani.ac.in/"),
      c(9, "ABV-IIITM Gwalior", "Madhya Pradesh", "JEE Main", "https://www.iiitm.ac.in/"),
      c(10, "IIIT Allahabad", "Uttar Pradesh", "JEE Main", "https://www.iiita.ac.in/"),
      c(11, "IIIT Hyderabad", "Telangana", "JEE Main", "https://www.iiit.ac.in/"),
      c(12, "IIT Guwahati", "Assam", "JEE Advanced", "http://www.iitg.ernet.in/"),
      c(13, "IIT (ISM) Dhanbad", "Jharkhand", "JEE Advanced", "https://www.iitism.ac.in/"),
      c(14, "IIT Gandhinagar", "Gujarat", "JEE Advanced", "https://iitgn.ac.in/"),
      c(15, "NIT Trichy", "Tamil Nadu", "JEE Main", "https://www.nitt.edu/"),
      c(16, "NIT Warangal", "Telangana", "JEE Main", "https://www.nitw.ac.in/"),
      c(17, "NIT Surathkal", "Karnataka", "JEE Main", "https://www.nitk.ac.in/"),
      c(18, "NIT Calicut", "Kerala", "JEE Main", "http://www.nitc.ac.in/"),
      c(19, "IIT Ropar", "Punjab", "JEE Advanced", "https://www.iitrpr.ac.in/"),
      c(20, "MNNIT Allahabad", "Uttar Pradesh", "JEE Main", "http://www.mnnit.ac.in/"),
    ],
  },
  {
    slug: "hotel-hospitality-tourism",
    name: "Hotel, Hospitality & Tourism Management",
    category: "Hospitality",
    icon: "Utensils",
    comingSoon: false,
    overview:
      "This vertical focuses on careers in the service industry — hotels, airlines, restaurants and travel agencies. The field is growing rapidly on the back of rising travel and demand for quality customer experiences, offering rewarding opportunities for those with a passion for service and creating memorable experiences.",
    degrees: [
      { name: "BHM (Bachelor of Hotel Management)", duration: "4 Years", eligibility: "10+2 any stream" },
      { name: "B.Sc. (Hospitality & Hotel Administration)", duration: "3 Years", eligibility: "10+2 any stream" },
      { name: "BHMCT (Hotel Management & Catering Technology)", duration: "4 Years", eligibility: "10+2 any stream" },
      { name: "BTTM (Tourism & Travel Management)", duration: "4 Years", eligibility: "10+2 any stream" },
      { name: "BA — various specializations", duration: "3 Years", eligibility: "10+2 any stream" },
      { name: "BBA — various specializations", duration: "3 Years", eligibility: "10+2 any stream" },
    ],
    specializations: [
      "Dietetics & Hospital Food Services", "Accommodation Operations & Management", "Front Office Operations",
      "Sales & Marketing", "Housekeeping", "Food Production", "Hospitality Administration",
      "Tourism and Travel Management", "Food & Beverage Services", "Bakery & Confectionery",
      "Front Desk Management", "Catering Technology",
    ],
    careers: [
      "Airline Catering / Cabin Service", "Entrepreneurship", "Indian Armed Forces", "Shipping and Cruise Lines",
      "Marketing & Sales with Hotels", "Teaching", "Hospital Catering", "Railway Catering Services",
      "Indian Civil Services", "Hospitality Services", "Restaurants & Fast Food Outlets", "Merchant Navy",
    ],
    exams: [
      { name: "NCHM-JEE", url: "https://nchmjee.nta.nic.in/" },
      { name: "IHM-A", url: "https://ihmaurangabad.ac.in/" },
      { name: "MET (Manipal)", url: "https://apply.manipal.edu/" },
      { name: "STEP (Oberoi)", url: "https://www.oberoigroup.com/" },
      { name: "BHMCT-CET (IPU)", url: "http://www.ipu.ac.in/" },
      { name: "CUET (Christ University)", url: "https://christuniversity.in/" },
      { name: "MAH-BHMCT-CET", url: "http://cetcell.mahacet.org/" },
      { name: "HM CET-BVP", url: "https://bvuniversity.edu.in/" },
      { name: "JMI-ET", url: "http://jmicoe.in/" },
      { name: "UGAT (AIMA)", url: "https://apps.aima.in/" },
      { name: "NMIMS-NPAT", url: "https://nmimsnpat.in/" },
    ],
    colleges: [
      c(1, "IHM Catering & Nutrition, Pusa", "New Delhi", "NCHM-JEE", "https://ihmpusa.net/"),
      c(2, "IHM Aurangabad", "Aurangabad", "IHM-A", "https://ihmaurangabad.ac.in/"),
      c(3, "Welcomgroup Graduate School of Hotel Administration", "Manipal", "MET", "https://manipal.edu/wgsha.html"),
      c(4, "Oberoi Group of Hotels (STEP)", "Pan-India", "STEP", "https://www.oberoigroup.com/"),
      c(5, "IHM Catering Technology & Applied Nutrition", "Mumbai", "NCHM-JEE", "http://www.ihmctan.edu/"),
      c(6, "IHM Catering Technology & Applied Nutrition", "Hyderabad", "NCHM-JEE", "http://www.ihmhyd.org/"),
      c(7, "IHM Catering Technology & Applied Nutrition", "Chennai", "NCHM-JEE", "http://www.ihmchennai.org/"),
      c(8, "IHM Catering Technology & Applied Nutrition", "Lucknow", "NCHM-JEE", "https://www.ihmlucknow.com/"),
      c(9, "Banarsidas Chandiwala IHM & Catering Technology", "New Delhi", "NCHM-JEE", "https://www.bcihmct.ac.in/"),
      c(10, "Dr. Ambedkar IHM Catering & Nutrition", "Chandigarh", "NCHM-JEE", "https://www.ihmchandigarh.org/"),
      c(11, "Army Institute of Hotel Management & Catering Technology", "Bengaluru", "OAT", "http://www.aihmctbangalore.edu.in/"),
      c(12, "IHM Catering Technology & Applied Nutrition", "Kolkata", "NCHM-JEE", "https://ihmkol.org/"),
      c(13, "IHM Catering & Nutrition", "Bhopal", "NCHM-JEE", "https://ihmbhopal.ac.in/"),
      c(14, "Dept. of Hotel Management, Christ University", "Bengaluru", "CUET", "https://christuniversity.in/campus"),
      c(15, "IHM & Catering Technology", "Trivandrum", "NCHM-JEE", "https://www.ihmctkovalam.ac.in/"),
      c(16, "IHM Catering & Nutrition", "Shimla", "NCHM-JEE", "https://ihmshimla.org/"),
      c(17, "Bharati Vidyapeeth", "Pune", "CET-BVP", "https://bvuniversity.edu.in/"),
      c(18, "IHM Catering & Nutrition", "Gurdaspur", "NCHM-JEE", "https://www.ihmgurdaspur.org/"),
      c(19, "Amity School of Hospitality", "Noida", "Based on 12th Marks", "https://www.amity.edu/ash/"),
      c(20, "School of Hospitality & Tourism, D.Y. Patil University", "Navi Mumbai", "Based on 12th Marks", "http://www.dypatil.edu/"),
      c(21, "IHM Catering Technology & Applied Nutrition", "Dehradun", "NCHM-JEE", "https://ihmddn.com/"),
      c(22, "IHM Catering Technology & Applied Nutrition", "Bhubaneswar", "NCHM-JEE", "https://www.ihmbbs.org/"),
      c(23, "Ashok Institute of Hospitality & Tourism Management (ITDC)", "New Delhi", "NCHM-JEE", "https://itdc.co.in/"),
      c(24, "IHM Catering Technology & Applied Nutrition", "Hajipur", "NCHM-JEE", "https://www.ihmhajipur.net/"),
      c(25, "SRM Institute of Hotel Management", "Chennai", "NCHM-JEE", "https://www.srmist.edu.in/"),
      c(26, "Chitkara School of Hospitality", "Rajpura", "Based on 12th Marks", "https://www.chitkara.edu.in/hospitality"),
      c(27, "Guru Nanak Institute of Hotel Management", "Kolkata", "Based on 12th Marks", "https://www.gnihm.ac.in/"),
      c(28, "International Institute of Hotel Management", "Kolkata", "Based on 12th Marks", "https://www.iihm.ac.in/"),
      c(29, "ITM Institute of Hotel Management", "Navi Mumbai", "Based on 12th Marks", "https://www.itm.edu/"),
      c(30, "School of Hospitality & Tourism, Galgotias University", "Greater Noida", "Based on 12th Marks", "https://www.galgotiasuniversity.edu.in/"),
    ],
  },
  {
    slug: "law",
    name: "Law",
    category: "Law",
    icon: "Scale",
    comingSoon: false,
    overview:
      "The legal profession is a vocation based on the knowledge of law and its applications. Lawyers study, promote, uphold and enforce rules imposed by authority — working as courtroom litigators or as consultants and legal advisors, handling civil and criminal matters through litigation, arbitration, negotiation and conciliation.",
    degrees: [
      { name: "BA LL.B. (Hons.)", duration: "5 Years", eligibility: "10+2 any stream" },
      { name: "B.Com LL.B. (Hons.)", duration: "5 Years", eligibility: "10+2 any stream" },
      { name: "BBA LL.B. (Hons.)", duration: "5 Years", eligibility: "10+2 any stream" },
      { name: "BSW LL.B. (Hons.)", duration: "5 Years", eligibility: "10+2 any stream" },
      { name: "B.Sc LL.B. (Hons.)", duration: "5 Years", eligibility: "10+2 with PCM/B" },
      { name: "B.Tech LL.B. (Hons.)", duration: "6 Years", eligibility: "10+2 with PCM" },
    ],
    specializations: [
      "Constitutional Law", "Administrative Law", "Human Rights Law", "Finance/Banking/Securities Law",
      "Jurisprudence", "Personal Laws", "Media/Entertainment Law", "Laws of Taxation",
      "International Humanitarian Law", "Intellectual Property Law", "Bioethics & Health Law",
      "Environmental Law", "Alternative Dispute Resolution", "Transitional Justice", "Labour & Social Security Law",
      "Cyber Law & Cyber Security", "International Law", "Public International Law", "Business Law",
      "Criminal Law", "Energy Law",
    ],
    careers: [
      "Litigation", "Judiciary", "Higher Studies", "Legal Consultant", "International Organizations",
      "Government Job", "Indian Defence Services", "Social Work", "Legal Process Outsourcing",
      "Higher Studies in Management", "Merchant Navy", "Research & Academics", "Alternate Dispute Resolution",
      "Indian Civil Services", "Banking & Insurance",
    ],
    exams: [
      { name: "CLAT (UG)", url: "https://consortiumofnlus.ac.in/" },
      { name: "AILET", url: "https://nludelhi.ac.in/" },
      { name: "LSAT India", url: "https://www.discoverlaw.in/" },
      { name: "SLAT (Symbiosis)", url: "https://www.set-test.org/" },
      { name: "MH-CET Law", url: "http://cetcell.mahacet.org/" },
      { name: "CUET (Christ University)", url: "https://christuniversity.in/" },
      { name: "LLB-CET (BVP)", url: "https://bvuniversity.edu.in/" },
      { name: "ULSAT (UPES)", url: "https://www.upes.ac.in/" },
      { name: "KIIT-EE", url: "https://kiit.ac.in/" },
      { name: "AIL-LET", url: "https://www.ail.ac.in/" },
      { name: "DU-LLB Entrance", url: "https://nta.ac.in/" },
      { name: "JMI-ET", url: "https://www.jmi.ac.in/" },
      { name: "MITWPU-UGPET", url: "https://mitwpu.edu.in/" },
    ],
    colleges: [
      c(1, "NLSIU", "Bangalore", "CLAT", "https://www.nls.ac.in/"),
      c(2, "NALSAR", "Hyderabad", "CLAT", "https://www.nalsar.ac.in/"),
      c(3, "WBNUJS", "Kolkata", "CLAT", "https://www.nujs.edu/"),
      c(4, "NLU", "Jodhpur", "CLAT", "http://www.nlujodhpur.ac.in/"),
      c(5, "NLU", "Delhi", "AILET", "https://nationallawuniversitydelhi.in/"),
      c(6, "GNLU", "Gandhinagar", "CLAT", "https://www.gnlu.ac.in/"),
      c(7, "NLIU", "Bhopal", "CLAT", "https://nliu.ac.in/"),
      c(8, "HNLU", "Raipur", "CLAT", "https://hnlu.ac.in/"),
      c(9, "RMLNLU", "Lucknow", "CLAT", "http://www.rmlnlu.ac.in/"),
      c(10, "RGNLU", "Patiala", "CLAT", "https://www.rgnul.ac.in/"),
      c(11, "CNLU", "Patna", "CLAT", "http://cnlu.ac.in/"),
      c(12, "MNLU", "Mumbai", "CLAT", "https://mnlumumbai.edu.in/"),
      c(13, "NUALS", "Kochi", "CLAT", "https://www.nuals.ac.in/"),
      c(14, "NUSRL", "Ranchi", "CLAT", "http://www.nusrlranchi.ac.in/"),
      c(15, "NLU & JA", "Guwahati", "CLAT", "http://www.nluassam.ac.in/"),
      c(16, "NLU", "Cuttack", "CLAT", "https://www.nluo.ac.in/"),
      c(17, "DSNLU", "Visakhapatnam", "CLAT", "https://dsnlu.ac.in/"),
      c(18, "TNNLS", "Trichy", "CLAT", "https://www.tnnlu.ac.in/"),
      c(19, "MNLU", "Nagpur", "CLAT", "https://www.nlunagpur.ac.in/"),
      c(20, "HPNLU", "Shimla", "CLAT", "https://hpnlu.ac.in/"),
      c(21, "MNLU", "Aurangabad", "CLAT", "https://www.mnlua.ac.in/"),
      c(22, "DNLU", "Jabalpur", "CLAT", "https://www.mpdnlu.ac.in/"),
      c(23, "DBRANLU", "Sonipat", "CLAT", "http://www.dbranlu.ac.in/"),
      c(1, "Government Law College (GLC)", "Mumbai", "MH-CET", "https://www.glcmumbai.com/", "Non-NLU"),
      c(2, "ILS Law College", "Pune", "MH-CET", "https://ilslaw.edu/", "Non-NLU"),
      c(3, "Banaras Hindu University", "Varanasi", "BLAT", "https://www.bhu.ac.in/", "Non-NLU"),
      c(4, "Punjab University", "Chandigarh", "LLB-ET", "https://puchd.ac.in/", "Non-NLU"),
      c(5, "Jamia Millia Islamia", "Delhi", "JMI-ET", "https://www.jmi.ac.in/", "Non-NLU"),
      c(6, "Aligarh Muslim University", "Aligarh", "AMU", "https://www.amu.ac.in/", "Non-NLU"),
      c(7, "Symbiosis Law School", "Pune", "SLAT", "https://www.symlaw.ac.in/", "Non-NLU"),
      c(8, "Jindal Global Law School", "Sonepat", "LSAT", "https://jgu.edu.in/jgls", "Non-NLU"),
      c(9, "Christ University", "Bangalore", "CUET", "https://christuniversity.in/", "Non-NLU"),
      c(10, "Institute of Law, Nirma University", "Ahmedabad", "CLAT", "https://law.nirmauni.ac.in/", "Non-NLU"),
      c(11, "UPES", "Dehradun", "ULSAT/CLAT/LSAT", "https://www.upes.ac.in/", "Non-NLU"),
      c(12, "KIIT Law School", "Bhubaneshwar", "KIIT-ET", "https://law.kiit.ac.in/", "Non-NLU"),
    ],
  },
  {
    slug: "liberal-studies",
    name: "Liberal Studies",
    category: "Liberal Arts",
    icon: "Library",
    comingSoon: false,
    overview:
      "Liberal Studies is a comprehensive, interdisciplinary program exploring fundamental principles across literature, philosophy, mathematics, social and physical sciences. It fosters intellectual curiosity and critical thinking, equipping students with the essential skills for active participation in civic and professional life.",
    degrees: [
      { name: "BA / BA (Hons.)", duration: "3/4 Years", eligibility: "10+2 any stream" },
      { name: "B.Com / B.Com (Hons.)", duration: "3/4 Years", eligibility: "10+2 any stream" },
      { name: "BBA / BBA (Hons.)", duration: "3 Years", eligibility: "10+2 any stream" },
      { name: "B.Sc / B.Sc (Hons.)", duration: "3/4 Years", eligibility: "10+2 with PCM/B" },
    ],
    specializations: [
      "Literary & Cultural Studies", "Event Management", "Mass Media", "Economics", "Journalism & New Media",
      "Marketing & Advertising", "Psychology", "Social Studies", "Mathematics", "Business Administration",
      "International Studies", "Public Administration", "Finance", "Film & TV", "Human Resource",
      "Environment Studies", "International Business", "Marketing", "Linguistics",
    ],
    careers: [
      "Public Relations", "Business Analyst", "Creative Writing", "Environmental Affairs", "Journalism",
      "Political Analyst", "Higher Studies in Management", "Indian Civil Services", "International Business",
      "Banking / Insurance", "Indian Armed Forces", "Merchant Navy", "NGOs", "Entrepreneurship",
      "Government/Private Job", "Higher Studies",
    ],
    exams: [
      { name: "AAT (Ashoka)", url: "https://www.ashoka.edu.in/" },
      { name: "FEAT (FLAME)", url: "https://www.flame.edu.in/" },
      { name: "SET-General (Symbiosis)", url: "https://www.set-test.org/" },
      { name: "PDEU-SP", url: "http://sls.pdpu.ac.in/" },
      { name: "KUAT (Karnavati)", url: "https://karnavatiuniversity.edu.in/" },
      { name: "NMIMS-NPAT", url: "https://nmimsnpat.in/" },
      { name: "JSAT (Jindal)", url: "https://jgu.edu.in/" },
      { name: "KREA Admission", url: "https://krea.edu.in/" },
      { name: "CUET (Christ University)", url: "https://christuniversity.in/" },
      { name: "MITWPU-AS", url: "https://mitwpu.edu.in/" },
      { name: "TSLAS-OT (Thapar)", url: "https://tslas.thapar.edu/" },
      { name: "VUSAT (Vijaybhoomi)", url: "https://vijaybhoomi.edu.in/" },
    ],
    colleges: [
      c(1, "FLAME University", "Pune", "FEAT", "https://www.flame.edu.in/"),
      c(2, "Pandit Deendayal Energy University", "Gandhinagar", "PDPU-ET", "https://sls.pdpu.ac.in/"),
      c(3, "Ashoka University", "Sonipat", "AAT", "https://www.ashoka.edu.in/"),
      c(4, "Symbiosis School of Liberal Arts", "Pune", "SET", "https://www.set-test.org/"),
      c(5, "KREA University", "Chennai", "Own Test", "https://krea.edu.in/"),
      c(6, "Azim Premji University", "Bangalore", "Own Test", "https://azimpremjiuniversity.edu.in/"),
      c(7, "Ahmedabad University", "Ahmedabad", "SOP + PI", "https://ahduni.edu.in/"),
      c(8, "Shiv Nadar University", "Delhi NCR", "SNUSAT & APT", "https://snu.edu.in/"),
      c(9, "Christ University", "Bangalore", "CUET", "https://christuniversity.in/"),
      c(10, "Jindal School of Liberal Arts & Humanities", "Sonipat", "JSAT", "https://jgu.edu.in/jslh/"),
      c(11, "Narsee Monjee (NMIMS)", "Mumbai", "NPAT", "https://liberalarts.nmims.edu/"),
      c(12, "Karnavati University", "Ahmedabad", "KUAT", "https://karnavatiuniversity.edu.in/uslm/"),
      c(13, "School of Liberal Arts, SRM University", "Amaravati", "Own Test", "https://srmap.edu.in/"),
      c(14, "MIT World Peace University", "Pune", "Own Test", "https://mitwpu.edu.in/"),
      c(15, "Thapar Institute of Engineering & Technology", "Patiala", "TIET Test", "https://tslas.thapar.edu/"),
      c(16, "Ajeenkya D.Y. Patil University", "Pune", "ADYPU Test", "https://adypu.edu.in/"),
      c(17, "ERA University", "Lucknow", "Own Test", "https://www.erauniversity.in/"),
      c(18, "School of Liberal Arts & Sciences, Mody University", "Sikar", "Based on 12th Marks", "https://www.modyuniversity.ac.in/"),
      c(19, "Bennett University", "Greater Noida", "Own Test", "https://www.bennett.edu.in/"),
      c(20, "RV University", "Bangalore", "Based on 12th Marks", "https://rvu.edu.in/"),
    ],
  },
  {
    slug: "mass-communication",
    name: "Mass Communication",
    category: "Media",
    icon: "Newspaper",
    comingSoon: false,
    overview:
      "Mass Communication is the dissemination of information across platforms — television, radio, film, newspapers, magazines and digital media. Beyond journalism it spans public relations, brand management, creative design and cinematography, making it a leading global profession with many unexplored career avenues.",
    degrees: [
      { name: "BA / BA (Hons.) — various", duration: "3/4 Years", eligibility: "10+2 any stream" },
      { name: "B.Sc — various", duration: "3 Years", eligibility: "10+2 any stream" },
      { name: "BMC (Bachelor of Mass Communication)", duration: "3 Years", eligibility: "10+2 any stream" },
      { name: "BMM (Bachelor of Mass Media)", duration: "3 Years", eligibility: "10+2 any stream" },
      { name: "B.JMC (Journalism & Mass Communication)", duration: "3 Years", eligibility: "10+2 any stream" },
      { name: "BA + MA (Integrated)", duration: "5 Years", eligibility: "10+2 any stream" },
    ],
    specializations: [
      "Advertising", "Digital Communication Management", "Public Relations", "Brand Management",
      "Marketing Analytics", "Media & Entertainment Management", "Sound", "Cinematography", "Journalism",
      "Print, Electronic & Social Media", "Writing", "Graphics",
    ],
    careers: [
      "DJ / VJ / RJ", "Copywriting", "Brand Management", "Indian Armed Forces", "Editing", "Creative Writing",
      "Public Relations", "Banking & Insurance", "Journalism", "Sound Mixing & Recording", "Higher Studies",
      "Government/Private Job", "Event Management", "Cinematography", "Indian Civil Services", "Entrepreneurship",
    ],
    exams: [
      { name: "CUET (UG)", url: "https://cuet.samarth.ac.in/" },
      { name: "St. Xavier's-ET", url: "https://xaviers.edu/" },
      { name: "SET-General (Symbiosis)", url: "https://www.set-test.org/" },
      { name: "CUET (Christ University)", url: "https://christuniversity.in/" },
      { name: "MET (Manipal)", url: "https://apply.manipal.edu/" },
      { name: "BJMC-CET (IPU)", url: "http://www.ipu.ac.in/" },
      { name: "MSU-ET", url: "https://admission.msubaroda.ac.in/" },
      { name: "JSAT (Jindal)", url: "https://home.pearsonvue.com/jsat.aspx" },
      { name: "KUAT (Karnavati)", url: "https://karnavatiuniversity.edu.in/" },
      { name: "WWI-ET (Whistling Woods)", url: "https://www.whistlingwoods.net/" },
      { name: "JMI-ET", url: "https://www.jmi.ac.in/" },
      { name: "KIIT-EE", url: "https://kiit.ac.in/" },
      { name: "UG-JET (Jain)", url: "https://www.jainuniversity.ac.in/" },
    ],
    colleges: [
      c(1, "St. Xavier's", "Mumbai", "BA MCJ Entrance Test", "https://xaviers.edu/"),
      c(2, "Indraprastha College for Women", "Delhi", "CUET (UG)", "http://www.ipcollege.ac.in/"),
      c(3, "Christ University", "Bangalore", "CUET", "https://christuniversity.in/"),
      c(4, "Lady Shri Ram College", "Delhi", "CUET (UG)", "https://lsr.edu.in/"),
      c(5, "Manipal University", "Manipal", "MET", "https://manipal.edu/"),
      c(6, "Mithibai College", "Mumbai", "Based on 12th Marks", "https://www.mithibai.ac.in/"),
      c(7, "Jai Hind College", "Mumbai", "Based on 12th Marks", "https://www.jaihindcollege.com/"),
      c(8, "Delhi College of Arts and Commerce", "Delhi", "CUET (UG)", "http://www.dcac.du.ac.in/"),
      c(9, "Sophia College for Women", "Mumbai", "Based on 12th Marks", "https://sophiacollegemumbai.com/"),
      c(10, "Symbiosis Centre for Media & Communication", "Pune", "SET", "https://scmc.edu.in/"),
      c(11, "Maharaja Agrasen College", "Delhi", "CUET (UG)", "http://www.mac.du.ac.in/"),
      c(12, "Madras Christian College", "Chennai", "Based on 12th Marks", "https://mcc.edu.in/"),
      c(13, "KPB Hinduja College", "Mumbai", "Based on 12th Marks", "https://hindujacollege.in/"),
      c(14, "HR College", "Mumbai", "Based on 12th Marks", "https://www.hrcollege.edu/"),
      c(15, "Kamala Nehru College for Women", "Delhi", "CUET (UG)", "https://knc.edu.in/"),
      c(16, "Whistling Woods International", "Mumbai", "WWI-ET", "https://www.whistlingwoods.net/"),
      c(17, "AJK Mass Communication Research Centre, JMI", "Delhi", "JMI-ET / CUET (UG)", "https://www.jmi.ac.in"),
      c(18, "Amity School of Communication", "Noida", "Based on 12th + Video", "https://www.amity.edu/asco/"),
      c(19, "Makhanlal Chaturvedi National Univ. of Journalism", "Bhopal", "Based on 12th Marks", "https://www.mcu.ac.in/"),
      c(20, "Jindal School of Journalism & Communication", "Sonipat", "JSAT", "https://jgu.edu.in/jsjc/"),
      c(21, "Indraprastha University", "Delhi", "BJMC-CET", "http://www.ipu.ac.in/"),
      c(22, "Kristu Jayanti College", "Bengaluru", "Based on 12th Marks", "https://kristujayanti.edu.in/"),
      c(23, "Mount Carmel College", "Bangalore", "Based on 12th Marks", "https://mccblr.edu.in/"),
      c(24, "St. Joseph's College (Autonomous)", "Bengaluru", "Based on 12th Marks", "https://www.sjc.ac.in/"),
      c(25, "Karnavati University", "Ahmedabad", "KUAT", "https://karnavatiuniversity.edu.in/"),
    ],
  },
  {
    slug: "medicine-surgery",
    name: "Medicine and Surgery",
    category: "Healthcare",
    icon: "Stethoscope",
    comingSoon: false,
    overview:
      "Medicine is the science and practice of diagnosing, treating and preventing disease. Modern medicine integrates biomedical sciences, research, genetics and technology, using pharmaceuticals, surgery and diverse therapies to maintain and restore health — blending practical skill with scientific knowledge. Admission to all streams is via NEET UG.",
    degrees: [
      { name: "MBBS (Medicine & Surgery)", duration: "5.5 Years", eligibility: "10+2 with PCB" },
      { name: "BDS (Dental Surgery)", duration: "5 Years", eligibility: "10+2 with PCB" },
      { name: "BAMS (Ayurvedic Medicine & Surgery)", duration: "5.5 Years", eligibility: "10+2 with PCB" },
      { name: "BSMS (Siddha Medicine & Surgery)", duration: "5.5 Years", eligibility: "10+2 with PCB" },
      { name: "BNYS (Naturopathy & Yogic Sciences)", duration: "5.5 Years", eligibility: "10+2 with PCB" },
      { name: "BHMS (Homeopathic Medicine & Surgery)", duration: "5.5 Years", eligibility: "10+2 with PCB" },
      { name: "BUMS (Unani Medicine & Surgery)", duration: "5.5 Years", eligibility: "10+2 with PCB" },
    ],
    specializations: [
      "Anaesthesiology", "Anatomy", "Aerospace Medicine", "Ayurveda", "Bio-Chemistry", "Dermatology",
      "Emergency Medicine", "ENT", "Family Medicine", "Forensic Medicine", "General Medicine", "General Surgery",
      "Geriatrics", "Homeopathy", "Hospital Administration", "Microbiology", "Naturopathy", "Nuclear Medicine",
      "Obstetrics & Gynaecology", "Ophthalmology", "Orthopaedics", "Paediatrics", "Pathology", "Pharmacology",
      "Physical Medicine & Rehabilitation", "Physiology", "Psychiatry", "Pulmonary Medicine", "Radiology",
      "Radiation Oncology", "Siddha", "Community Medicine", "Sports Medicine", "Transfusion Medicine",
      "Tropical Medicine", "Unani", "Venereology",
    ],
    careers: [
      "State/Central Civil Medical Service", "Higher Studies", "Technical Writing", "Higher Studies in Management",
      "Indian Civil Services", "Medical Consultant in Corporate Hospital", "Research in Medical/Pharma",
      "Medical Policy Making", "Teaching with Medical College", "Private Hospital or Clinic", "Clinical Research",
      "Medical Journalism", "Medical Equipment Manufacturing", "Indian Armed Forces", "Medical Tourism", "NGOs",
    ],
    exams: [{ name: "NEET UG", url: "https://neet.nta.nic.in/" }],
    colleges: [
      c(1, "AIIMS", "New Delhi", "NEET UG", "https://www.aiims.edu/en.html"),
      c(2, "Maulana Azad Medical College (MAMC)", "New Delhi", "NEET UG", "https://www.mamc.ac.in/"),
      c(3, "Christian Medical College (CMC)", "Vellore", "NEET UG", "https://www.cmch-vellore.edu/"),
      c(4, "Armed Forces Medical College (AFMC)", "Pune", "NEET UG", "https://www.afmc.nic.in/"),
      c(5, "Kasturba Medical College", "Manipal", "NEET UG", "https://manipal.edu/kmc-manipal.html"),
      c(6, "Lady Hardinge Medical College", "New Delhi", "NEET UG", "http://www.lhmc-hosp.gov.in/"),
      c(7, "University College of Medical Sciences", "New Delhi", "NEET UG", "https://ucms.ac.in/"),
      c(8, "Grant Government Medical College", "Mumbai", "NEET UG", "https://ggmcjjh.com/"),
      c(9, "King George's Medical University", "Lucknow", "NEET UG", "http://www.kgmu.org/"),
      c(10, "Seth GS Medical College & KEM Hospital", "Mumbai", "NEET UG", "https://www.kem.edu/"),
      c(11, "Mahatma Gandhi Institute of Medical Sciences", "Wardha", "NEET UG", "https://www.mgims.ac.in/"),
      c(12, "Sri Ramachandra Medical College", "Chennai", "NEET UG", "https://www.sriramachandra.edu.in/"),
      c(13, "Institute of Medical Sciences, BHU", "Varanasi", "NEET UG", "https://www.bhu.ac.in/ims/"),
      c(14, "Lokmanya Tilak Municipal Medical College", "Mumbai", "NEET UG", "http://www.ltmgh.com/"),
      c(15, "Bangalore Medical College & Research Institute", "Bengaluru", "NEET UG", "http://www.bmcri.org/"),
      c(16, "JIPMER", "Puducherry", "NEET UG", "https://jipmer.edu.in/"),
      c(17, "B.J. Government Medical College", "Pune", "NEET UG", "http://www.bjmcpune.org/"),
      c(18, "Osmania Medical College", "Hyderabad", "NEET UG", "https://osmaniamedicalcollege.org/"),
      c(19, "Amrita School of Medicine", "Kochi", "NEET UG", "https://www.amritahospitals.org/"),
      c(20, "Medical College and Hospital Kolkata", "Kolkata", "NEET UG", "https://www.medicalcollegekolkata.in/"),
      c(21, "Vardhman Mahavir Medical College", "New Delhi", "NEET UG", "http://vmmc-sjh.nic.in/"),
      c(22, "Government Medical College & Hospital (GMCH)", "Chandigarh", "NEET UG", "http://gmch.gov.in/"),
      c(23, "Sawai Man Singh Medical College", "Jaipur", "NEET UG", "https://education.rajasthan.gov.in/"),
      c(24, "Jawaharlal Nehru Medical College, AMU", "Aligarh", "NEET UG", "https://www.amu.ac.in/"),
      c(25, "St. John's Medical College", "Bengaluru", "NEET UG", "https://www.stjohns.in/medicalcollege/"),
      c(26, "AIIMS", "Jodhpur", "NEET UG", "http://aiimsjodhpur.edu.in/"),
      c(27, "Dayanand Medical College & Hospital", "Ludhiana", "NEET UG", "https://www.dmch.edu/"),
      c(28, "M.S. Ramaiah Medical College", "Bengaluru", "NEET UG", "https://msrmc.ac.in/"),
      c(29, "AIIMS", "Bhubaneswar", "NEET UG", "https://aiimsbhubaneswar.nic.in/"),
      c(30, "Maulana Azad Institute of Dental Sciences", "New Delhi", "NEET UG", "https://www.maids.ac.in/", "Dental"),
      c(31, "Manipal College of Dental Sciences", "Manipal", "NEET UG", "https://manipal.edu/", "Dental"),
      c(32, "Government Dental College and Hospital", "Mumbai", "NEET UG", "http://www.gdcmumbai.org/", "Dental"),
      c(33, "Faculty of Dental Sciences, KGMU", "Lucknow", "NEET UG", "https://www.kgmu.org/", "Dental"),
      c(34, "SDM College of Dental Sciences & Hospital", "Dharwad", "NEET UG", "https://www.sdmcds.org/", "Dental"),
    ],
  },
  {
    slug: "paramedical-sciences",
    name: "Paramedical Sciences",
    category: "Healthcare",
    icon: "HeartPulse",
    comingSoon: false,
    overview:
      "Paramedical Science offers pre-hospital emergency and non-surgical care, supplementing medical professionals. It is a rapidly growing field demanding trained individuals to support healthcare systems — a rewarding path for those interested in problem-solving and improving people's lives.",
    degrees: [
      { name: "B.Sc. Nursing", duration: "4 Years", eligibility: "10+2 with PCM/B" },
      { name: "B.Optom. (Optometry)", duration: "4 Years", eligibility: "10+2 with PCM/B" },
      { name: "BOT (Occupational Therapy)", duration: "4.5 Years", eligibility: "10+2 with PCM/B" },
      { name: "BPT (Physiotherapy)", duration: "4.5 Years", eligibility: "10+2 with PCM/B" },
      { name: "B.Sc. — multiple specializations", duration: "4 Years", eligibility: "10+2 with PCM/B" },
      { name: "B.Pharma (Pharmacy)", duration: "4 Years", eligibility: "10+2 with PCM/B" },
      { name: "Pharm.D (Doctor of Pharmacy)", duration: "6 Years", eligibility: "10+2 with PCM/B" },
    ],
    specializations: [
      "Anaesthesia Technology", "Auxiliary Nurse Midwife", "Cardiovascular Technology", "Critical Care",
      "Dialysis Technology", "Exercise & Sports Science", "General Nursing and Midwifery",
      "Health Information Management", "Medical Imaging Technology", "Medical Laboratory Technology",
      "Medical Record Technology", "Nuclear Medicine Technology", "Nursing", "Occupational Therapy",
      "Operation Theatre Technology", "Ophthalmic Technology", "Optometry", "Perfusion Technology", "Pharmacy",
      "Physiotherapy", "Radio Therapy Technology", "Respiratory Therapy", "Trauma Care Management", "X-Ray Technology",
    ],
    careers: [
      "Pharmaceutical Drug Manufacturing", "Private Hospital or Clinic", "Assistantship", "Medical Tourism",
      "Specialist Consultant (Government Hospital)", "Higher Studies", "Specialist Consultant (Corporate Hospital)",
      "Clinical Research", "Central Civil Medical Service", "Medical Equipment Manufacturing",
      "Indian Civil Services", "Research and Academics", "Indian Armed Forces", "Medical Journalism", "Technical Writing",
    ],
    exams: [
      { name: "NEET UG", url: "https://neet.nta.nic.in/" },
      { name: "AIIMS-EE", url: "https://aiimsexams.ac.in/" },
      { name: "JIPMER-EE", url: "https://www.jipmer.edu.in/" },
      { name: "AFMC-EE", url: "https://www.afmc.nic.in/" },
      { name: "MHT-CET", url: "http://cetcell.mahacet.org" },
      { name: "WBJEE / JENPAS-UG", url: "https://wbjeeb.in/" },
      { name: "OJEE Form A", url: "https://ojee.nic.in/" },
      { name: "Paramedical CET (IPU)", url: "http://www.ipu.ac.in/" },
      { name: "KEA-CET", url: "https://cetonline.karnataka.gov.in/kea/" },
      { name: "TS-EAMCET (AM)", url: "https://eamcet.tsche.ac.in/" },
      { name: "PGIMER-EE", url: "https://pgimer.edu.in/" },
      { name: "BITSAT (Pharmacy)", url: "https://www.bitsadmission.com/" },
    ],
    colleges: [
      c(1, "College of Nursing, AIIMS", "New Delhi", "AIIMS-EE", "https://www.aiims.edu/", "Nursing"),
      c(2, "AFMC College of Nursing", "Pune", "AFMC-EE", "https://afmc.nic.in/", "Nursing"),
      c(3, "College of Nursing, JIPMER", "Puducherry", "JIPMER-EE", "https://jipmer.edu.in/", "Nursing"),
      c(4, "College of Nursing, CMC", "Vellore", "CMC-CBT", "https://concmc.org/", "Nursing"),
      c(5, "Sri Ramachandra College of Nursing", "Chennai", "SRU-EE", "https://www.sriramachandra.edu.in/", "Nursing"),
      c(6, "National Institute of Nursing Education, PGI", "Chandigarh", "PGIMER-EE", "https://pgimer.edu.in/", "Nursing"),
      c(7, "Rajkumari Amrit Kaur College of Nursing", "New Delhi", "RACKON-ST", "http://rakcon.com/", "Nursing"),
      c(8, "KGMU College of Nursing", "Lucknow", "B.Sc NC EE", "https://www.kgmu.org/", "Nursing"),
      c(9, "College of Nursing, Lady Hardinge Medical College", "New Delhi", "LHMC EE", "http://lhmc-hosp.gov.in/", "Nursing"),
      c(10, "NIMHANS Dept. of Nursing", "Bengaluru", "Based on 12th Marks", "https://nimhans.ac.in/", "Nursing"),
      c(1, "Panjab University", "Chandigarh", "PU CET", "https://puchd.ac.in/", "Pharmacy"),
      c(2, "BITS Pilani", "Rajasthan", "BITSAT", "https://www.bits-pilani.ac.in/", "Pharmacy"),
      c(3, "Jadavpur University", "Kolkata", "WBJEE", "http://www.jaduniv.edu.in/", "Pharmacy"),
      c(4, "BIT Mesra", "Jharkhand", "JEE Main / NEET", "https://www.bitmesra.ac.in/", "Pharmacy"),
      c(5, "MAHE", "Manipal", "MET", "https://manipal.edu/", "Pharmacy"),
      c(6, "Annamalai University", "Chidambaram", "Merit", "https://annamalaiuniversity.ac.in/", "Pharmacy"),
      c(1, "School of Physiotherapy, KEM Hospital", "Mumbai", "NEET", "https://www.kem.edu/", "Physiotherapy"),
      c(2, "School of Physiotherapy, CMC", "Vellore", "CET", "https://www.cmch-vellore.edu/", "Physiotherapy"),
      c(3, "College of Physiotherapy, PGI", "Chandigarh", "Based on 12th Marks", "https://pgimer.edu.in/", "Physiotherapy"),
      c(1, "Elite School of Optometry", "Chennai", "NEET", "http://www.eso.sankaranethralaya.org/", "Optometry"),
      c(2, "Sri Ramachandra University Dept. of Optometry", "Chennai", "SRC-AIEE", "https://www.sriramachandra.edu.in/", "Optometry"),
    ],
  },
  {
    slug: "performing-arts",
    name: "Performing Arts",
    category: "Arts",
    icon: "Music",
    comingSoon: false,
    overview:
      "Performing Arts uses artists' voices, bodies and instruments to express artistic ideas to a live audience. The field offers practical, hands-on experience in cutting-edge practice, preparing students for a competitive industry across music, dance and theatre.",
    degrees: [
      { name: "BA / BA (Hons.) — various", duration: "3/4 Years", eligibility: "10+2 any stream" },
      { name: "B.Music (Bachelor of Music)", duration: "3/4 Years", eligibility: "10+2 any stream" },
      { name: "BFA (Bachelor of Fine Arts)", duration: "3/4 Years", eligibility: "10+2 any stream" },
      { name: "BPA (Bachelor of Performing Arts)", duration: "3/4 Years", eligibility: "10+2 any stream" },
    ],
    specializations: [
      "Classical Vocal", "Classical Dance", "Dramatics / Theatre Arts", "Western Vocal", "Western Dance",
      "Air-based Instrument Playing", "String-based Instrument Playing",
    ],
    careers: [
      "Acting Industry", "Advertising Agency", "Musical Theatre Performer", "Art Administration",
      "Dancing & Choreography", "Higher Studies", "Dance/Music/Drama Therapist", "Broadcasting Presentation",
      "Music & Composition", "Indian Civil Services", "Indian Armed Forces", "Theatre Direction",
      "Teacher / Lecturer", "Talent/Celebrity Management", "Screen Writing", "Theatre Stage Manager",
    ],
    exams: [
      { name: "CUET (UG)", url: "https://cuet.samarth.ac.in/" },
      { name: "CUET (Christ University)", url: "https://christuniversity.in/" },
      { name: "MSU-AT", url: "https://admission.msubaroda.ac.in/" },
      { name: "WWI-ET (Whistling Woods)", url: "https://www.whistlingwoods.net/" },
      { name: "NMIMS Audition", url: "http://performingarts.nmims.edu/" },
      { name: "BHU-UET", url: "https://www.bhu.ac.in/" },
    ],
    colleges: [
      c(1, "Allahabad University", "Prayagraj", "AU-UET", "https://www.allduniv.ac.in/"),
      c(2, "Annamalai University", "Tamil Nadu", "Based on 12th Marks", "https://annamalaiuniversity.ac.in/"),
      c(3, "Visva Bharati University", "West Bengal", "VBU-AT", "https://visvabharati.ac.in/"),
      c(4, "Banasthali Vidyapeeth", "Jaipur", "BV-AT", "http://www.banasthali.org/"),
      c(5, "M.S. University of Baroda", "Gujarat", "MSU-AT", "https://www.msubaroda.ac.in/"),
      c(6, "Andhra University", "Visakhapatnam", "Based on 12th Marks", "https://www.andhrauniversity.edu.in/"),
      c(7, "Banaras Hindu University", "Varanasi", "BHU-UET", "https://www.bhu.ac.in/"),
      c(8, "Christ University", "Bangalore", "CUET", "https://christuniversity.in/"),
      c(9, "Mumbai University", "Mumbai", "Audition Test", "https://mu.ac.in/"),
      c(10, "Indira Kala Sangeet Vishwavidyalaya", "Chhattisgarh", "IKSV-AT", "https://www.iksv.ac.in/"),
      c(11, "Rajasthan University", "Jaipur", "RU-EAT", "https://www.uniraj.ac.in/"),
      c(12, "Kannada University", "Karnataka", "Based on 12th Marks", "http://kannadauniversity.org/"),
      c(13, "Bharati Vidyapeeth", "Pune", "BV-CEPT", "https://bvuniversity.edu.in/"),
      c(14, "Calicut University", "Kerala", "Based on 12th Marks", "https://uoc.ac.in/"),
      c(15, "Gujarat University", "Ahmedabad", "Based on 12th Marks", "https://www.gujaratuniversity.ac.in/"),
    ],
  },
  {
    slug: "pure-sciences",
    name: "Pure Sciences",
    category: "Sciences",
    icon: "Atom",
    comingSoon: false,
    overview:
      "Pure Science is the study of natural phenomena through observation and experimentation, developing theories and predictions. It is a fundamental field focused on understanding the universe and its constituents across physics, chemistry, biology, mathematics and statistics.",
    degrees: [
      { name: "B.Sc. (Hons.)", duration: "3/4 Years", eligibility: "10+2 with PCM/B" },
      { name: "B.Sc.", duration: "3 Years", eligibility: "10+2 with PCM/B" },
      { name: "B.Stat. (Bachelor of Statistics)", duration: "4 Years", eligibility: "10+2 with Stats/Maths" },
      { name: "B.Sc. + M.Sc. (Integrated)", duration: "5 Years", eligibility: "10+2 with PCM/B" },
    ],
    specializations: [
      "Chemistry", "Physics", "Mathematics", "Statistics", "Biochemistry", "Botany", "Zoology", "Microbiology",
      "Biotechnology", "Bioinformatics", "Genetics", "Life Sciences", "Forensic Science", "Environmental Science",
      "Computer Science", "Electronics", "Geology", "Food Technology", "Nutrition & Dietetics", "Psychology",
    ],
    careers: [
      "Higher Studies", "Public Sector Undertaking", "Indian Civil Services", "Merchant Navy",
      "Indian Armed Forces", "Banking Job", "Defence Research Organizations", "Central Research Organizations",
      "State Research Organizations", "Teaching",
    ],
    exams: [
      { name: "IISER Aptitude Test (IAT)", url: "https://www.iiseradmission.in/" },
      { name: "JEE Main", url: "http://www.jeemain.nta.nic.in/" },
      { name: "JEE Advanced", url: "https://www.jeeadv.ac.in/" },
      { name: "NEET UG", url: "https://neet.nta.nic.in/" },
      { name: "NEST", url: "https://www.nestexam.in/" },
      { name: "CUET (UG)", url: "https://cuet.samarth.ac.in/" },
      { name: "BITSAT", url: "https://www.bitsadmission.com/" },
      { name: "CMI-EE", url: "https://www.cmi.ac.in/" },
      { name: "ISI-AT", url: "https://www.isical.ac.in/" },
      { name: "BHU-UET", url: "https://www.bhu.ac.in/" },
      { name: "AMU-ET", url: "https://www.amu.ac.in/" },
    ],
    colleges: [
      c(1, "Indian Institute of Science", "Bangalore", "KVPY / JEE / NEET", "https://iisc.ac.in/"),
      c(2, "IIT Kharagpur", "Kharagpur", "JEE Advanced", "http://www.iitkgp.ac.in/"),
      c(3, "IIT Madras", "Chennai", "JEE Advanced", "https://www.iitm.ac.in/"),
      c(4, "IIT Roorkee", "Roorkee", "JEE Advanced", "https://www.iitr.ac.in/"),
      c(5, "IIT Bombay", "Mumbai", "JEE Advanced", "https://www.iitb.ac.in/"),
      c(6, "IIT Kanpur", "Kanpur", "JEE Advanced", "http://www.iitk.ac.in/"),
      c(7, "NIT Agartala", "Agartala", "JEE Main", "https://www.nita.ac.in/"),
      c(8, "NIT Durgapur", "Durgapur", "JEE Main", "https://nitdgp.ac.in/"),
      c(9, "NIT Rourkela", "Rourkela", "JEE Main", "https://www.nitrkl.ac.in/"),
      c(10, "IISER Kolkata", "Kolkata", "IAT / JEE Adv", "https://www.iiserkol.ac.in/"),
      c(11, "IISER Pune", "Pune", "IAT / JEE Adv", "https://www.iiserpune.ac.in/"),
      c(12, "UM-DAE Centre for Excellence in Basic Sciences", "Mumbai", "NEST", "https://www.cbs.ac.in/"),
      c(13, "NISER", "Bhubaneswar", "NEST", "https://www.niser.ac.in/"),
      c(14, "Chennai Mathematical Institute", "Chennai", "CMI-EE", "https://www.cmi.ac.in/"),
      c(15, "IISER Mohali", "Mohali", "IAT / JEE Adv", "https://www.iisermohali.ac.in/"),
    ],
  },
  {
    slug: "rehabilitation-sciences",
    name: "Rehabilitation Sciences",
    category: "Healthcare",
    icon: "Accessibility",
    comingSoon: false,
    overview:
      "Rehabilitation Sciences helps individuals regain independence and mobility for fuller, more fulfilling lives. Professionals treat temporarily or permanently disabled patients using purposeful activities, exercises and therapies to overcome daily limitations and prevent further disability.",
    degrees: [
      { name: "B.P.O. (Prosthetics and Orthotics)", duration: "4.5 Years", eligibility: "10+2 with PCM/PCB" },
      { name: "B.A.S.L.P. (Audiology & Speech Language Pathology)", duration: "4 Years", eligibility: "10+2 with PCM/PCB" },
      { name: "B.R.Sc. (Rehabilitation Science)", duration: "3 Years", eligibility: "10+2 with PCM/PCB" },
      { name: "BA/B.Com/B.Sc (Special Education)", duration: "4 Years", eligibility: "10+2 any stream" },
      { name: "B.Sc. (Special Education & Rehabilitation)", duration: "3 Years", eligibility: "10+2 with PCM/PCB" },
    ],
    specializations: [
      "Special Education (Visual Impairment)", "Special Education (Hearing Impairment)", "Special Education (Deaf-Blind)",
      "Special Education (Intellectual Disability)", "Mobility Science", "Prosthetics & Orthotics",
      "Audiology & Speech Language Pathology", "Clinical Psychology", "Rehabilitation Psychology", "Rehabilitation Science",
    ],
    careers: [
      "Higher Studies", "Specialist Consultant (Corporate Hospital)", "Special Education",
      "Clinical / Therapeutic Rehabilitation", "Rehabilitation Management & Administration", "Indian Civil Services",
      "Research and Academics", "State/Central Civil Medical Service", "Clinical Research", "Psychosocial Rehabilitation",
      "Hospitals / Clinics / Special Schools", "Work with NGOs", "Technical Writing", "Vocational Rehabilitation",
    ],
    exams: [
      { name: "AIISH-ET", url: "https://www.aiishmysore.in/" },
      { name: "Paramedical CET (IPU)", url: "http://www.ipu.ac.in/" },
      { name: "IMAT", url: "https://www.ihsindia.org/" },
      { name: "WB-JENPAS UG", url: "https://wbjeeb.nic.in/" },
      { name: "SVNIRTAR NET", url: "http://www.svnirtar.nic.in/" },
      { name: "SRU-EE", url: "https://www.sriramachandra.edu.in/" },
    ],
    colleges: [
      c(1, "All India Institute of Speech & Hearing", "Mysore", "AIISH-ET", "https://aiishmysore.in/", "Audiology"),
      c(2, "Bharati Vidyapeeth", "Pune", "BVP-CET", "https://bvuniversity.edu.in/", "Audiology"),
      c(3, "Institute of Health Sciences", "Bhubaneswar", "IMAT", "https://www.ihsindia.org/", "Audiology"),
      c(4, "JIPMER", "Puducherry", "JIPMER-EE", "https://jipmer.edu.in/", "Audiology"),
      c(5, "Dr. Shakuntala Misra National Rehabilitation University", "Lucknow", "DSMNRU-EE", "https://dsmru.up.nic.in/", "Audiology"),
      c(6, "National Institute for Empowerment of Persons with Multiple Disabilities", "Kovalam", "BASLP-NET", "https://niepmd.tn.nic.in/", "Audiology"),
      c(7, "PGIMER", "Chandigarh", "Based on 12th Marks", "https://pgimer.edu.in/", "Audiology"),
      c(8, "College of Allied Health Sciences, MAHE", "Manipal", "Based on 12th Marks", "https://manipal.edu/", "Audiology"),
      c(1, "Swami Vivekanand NIRTAR", "Cuttack", "CET", "http://www.svnirtar.nic.in/", "Prosthetics & Orthotics"),
      c(2, "Pandit Deendayal Upadhyaya Institute for the Physically Handicapped", "New Delhi", "Based on 12th Marks", "http://aiipmr.gov.in/", "Prosthetics & Orthotics"),
      c(3, "All India Institute of Physical Medicine & Rehabilitation", "Mumbai", "Based on 12th Marks", "https://rehabsciences.org/", "Prosthetics & Orthotics"),
      c(4, "National Institute for the Orthopaedically Handicapped", "Kolkata", "CET", "http://www.niohkol.nic.in/", "Prosthetics & Orthotics"),
      c(5, "Christian Medical College (CMC)", "Vellore", "Based on 12th Marks", "https://www.cmch-vellore.edu/", "Prosthetics & Orthotics"),
      c(6, "Indian Spinal Injuries Centre", "New Delhi", "CET", "http://www.isicinstitute.org/", "Prosthetics & Orthotics"),
    ],
  },
  {
    slug: "sports",
    name: "Sports & Physical Education",
    category: "Sports",
    icon: "Trophy",
    comingSoon: false,
    overview:
      "A career in Sports or Physical Education suits those with a strong interest in sports, games and management. Beyond playing, the field offers coaching, training, refereeing and sports management — requiring knowledge of fitness, nutrition, sports medicine and physiology.",
    degrees: [
      { name: "BA / BA (Hons.)", duration: "3/4 Years", eligibility: "10+2 any stream" },
      { name: "BBA (Business Administration)", duration: "3 Years", eligibility: "10+2 any stream" },
      { name: "B.Sc / B.Sc (Hons.)", duration: "3/4 Years", eligibility: "10+2 with science" },
      { name: "BPES (Physical Education and Sports)", duration: "3/4 Years", eligibility: "10+2 any stream" },
      { name: "B.P.Ed. (Physical Education)", duration: "2/3 Years", eligibility: "Bachelor's in relevant field" },
      { name: "BMS (Sports Management)", duration: "3 Years", eligibility: "10+2 any stream" },
    ],
    specializations: [
      "Physical Education, Health Education & Sports", "Sports Management", "Physical Education & Sports",
      "Sports & Exercise Sciences", "Sports Coaching", "Sports Psychology", "Physical Education", "Sports Nutrition",
      "Exercise Physiology & Nutrition", "Yoga",
    ],
    careers: [
      "Sports Management", "Athlete & Team Director", "Sports Consultation", "Sports Journalism / Commentating",
      "Indian Civil Services", "Sports Person", "Indian Railways", "Manufacturing Sports Equipment",
      "Umpire / Referee", "Indian Defence Forces", "Sports Coaching", "Fitness Training",
    ],
    exams: [
      { name: "SMAT-UG", url: "https://www.iismworld.com/" },
      { name: "CUET (UG)", url: "https://cuet.samarth.ac.in/" },
      { name: "NSUEE", url: "https://nsu.nta.ac.in/" },
      { name: "B.Sc.(Y)-CET (IPU)", url: "http://www.ipu.ac.in/" },
    ],
    colleges: [
      c(1, "Indira Gandhi Institute of Physical Education & Sports Sciences", "Delhi", "Entrance Based", "http://igipess.du.ac.in/"),
      c(2, "Manipal Academy of Higher Education", "Jamshedpur", "Own Test", "https://manipal.edu/"),
      c(3, "Maulana Abul Kalam Azad University of Technology", "West Bengal", "CET", "https://makautwb.ac.in/"),
      c(4, "College of Physical Education, Bharati Vidyapeeth", "Pune", "Based on 12th Marks", "https://copepune.bharatividyapeeth.edu/"),
      c(5, "Institute of Sports Science & Technology", "Pune", "Based on 12th Marks", "https://www.isst.co.in/"),
      c(6, "National Academy of Sports Management", "Mumbai", "Own Test", "https://www.nasm.edu.in/"),
      c(7, "Centre for Sports Science", "Chennai", "Based on 12th Marks", "https://www.csstrucoach.in/"),
      c(8, "National Sports University", "Imphal", "Based on 12th Marks", "https://www.nsu.ac.in/"),
      c(9, "Swarnim Gujarat Sports University", "Gujarat", "Written Test & Interview", "https://sgsu.gujarat.gov.in/"),
      c(10, "Tamil Nadu Physical Education & Sports University", "Chennai", "Based on 10+2 Marks", "https://www.tnpesu.org/"),
      c(11, "Lakshmibai National Institute of Physical Education", "Gwalior", "Based on 10+2 Marks", "http://www.lnipe.edu.in/"),
      c(12, "PES University", "Bangalore", "PESSAT", "https://pes.edu/"),
      c(13, "International Institute of Sports Management", "Mumbai", "SMAT", "https://www.iismworld.com/"),
    ],
  },
  {
    slug: "veterinary-fishery",
    name: "Veterinary & Fishery Sciences",
    category: "Sciences",
    icon: "PawPrint",
    comingSoon: false,
    overview:
      "Veterinary Sciences prepare students as veterinary doctors or field researchers, with curricula covering animal anatomy, physiology, diseases and public health — similar to human medicine. It is a competitive, respected field offering social status and the satisfaction of improving animal welfare. Admission is largely via NEET UG.",
    degrees: [
      { name: "B.V.Sc. & AH (Veterinary Sciences & Animal Husbandry)", duration: "5.5 Years", eligibility: "10+2 with PCB" },
      { name: "B.F.Sc. (Fisheries Sciences)", duration: "4 Years", eligibility: "10+2 with PCB" },
    ],
    specializations: [
      "Animal Biotechnology", "Aquaculture", "Livestock Production & Management", "Veterinary Anatomy",
      "Veterinary Medicine", "Veterinary Pharmacology & Toxicology", "Animal Genetics & Breeding",
      "Aquatic Environment Management", "Fish Processing Technology", "Mariculture", "Veterinary Microbiology",
      "Veterinary Physiology", "Veterinary Surgery & Radiology", "Dairy Science & Technology", "Fisheries",
      "Veterinary Biochemistry", "Veterinary Parasitology", "Veterinary Public Health", "Animal Nutrition",
      "Poultry Science", "Veterinary Pathology",
    ],
    careers: [
      "Indian Civil/Forest Services", "Higher Studies", "Indian Armed Forces", "Veterinary Equipment Manufacturing",
      "Technical Writing", "NGOs for Animal Welfare", "Veterinary Research", "Fish Breeding & Production",
      "Veterinary Journalism", "Private Veterinary Doctor", "Teaching with Veterinary College",
      "State/Central Civil Veterinary Services", "Veterinary Policy Making", "Cattle Breeding", "Wildlife Conservation",
    ],
    exams: [
      { name: "NEET UG", url: "https://neet.nta.nic.in/" },
      { name: "CETUG-AAU", url: "http://www.aau.ac.in/" },
      { name: "UP-CATET", url: "https://upcatetadmissions.org/" },
      { name: "BCECE", url: "https://bceceboard.bihar.gov.in/" },
      { name: "MHT-CET", url: "http://cetcell.mahacet.org" },
      { name: "KEA-CET", url: "https://cetonline.karnataka.gov.in/kea/" },
      { name: "OUAT", url: "http://ouat.nic.in/" },
      { name: "RPVT", url: "https://rajuvas.org/" },
      { name: "TS-EAMCET (AM)", url: "https://eamcet.tsche.ac.in/" },
      { name: "GBPUAT-CEE", url: "https://gbpuat.ac.in/" },
    ],
    colleges: [
      c(1, "Mumbai Veterinary College", "Mumbai", "NEET", "https://mvc.ac.in/"),
      c(2, "ICAR - Indian Veterinary Research Institute", "Bareilly", "NEET", "http://www.ivri.nic.in/"),
      c(3, "College of Veterinary & Animal Sciences", "Pantnagar", "GBPUA&T Test", "https://www.gbpuat.ac.in/"),
      c(4, "Madras Veterinary College", "Chennai", "Based on 12th Marks", "https://tanuvas.ac.in/"),
      c(5, "College of Veterinary Science & Research Institute", "Namakkal", "Based on 12th Marks", "https://tanuvas.ac.in/"),
      c(6, "Veterinary College and Research Institute", "Tirunelveli", "Based on 12th Marks", "https://tanuvas.ac.in/"),
      c(7, "College of Veterinary Science", "Guwahati", "Based on 12th Marks", "http://www.vetbifg.ac.in/"),
      c(8, "Ranchi College of Veterinary Science & Animal Husbandry", "Ranchi", "NEET", "https://www.bauranchi.org/"),
      c(9, "Nagpur Veterinary College", "Nagpur", "NEET", "https://www.nvcnagpur.net.in/"),
      c(10, "College of Veterinary Science & Animal Husbandry", "Faizabad", "NEET", "https://www.nduat.org/"),
      c(11, "Faculty of Veterinary Sciences, SKUAST", "Srinagar", "Based on 12th Marks", "https://www.skuastkashmir.ac.in/"),
      c(12, "Mahatma Jyotiba Fule College of Veterinary & Animal Science", "Jaipur", "NEET", "https://mjfveterinarycollege.org/"),
      c(13, "College of Veterinary & Animal Sciences", "Udgir", "MH-CET", "https://vcudg.in/"),
      c(14, "College of Veterinary Science & Animal Husbandry", "Aizawl", "AIEE", "https://cvsccauaizawl.edu.in/"),
      c(15, "College of Veterinary Science", "Tirupati", "Based on 12th Marks (PCB)", "https://svvu.edu.in/"),
    ],
  },
  {
    slug: "vocational-studies",
    name: "Vocational Studies",
    category: "Vocational",
    icon: "Wrench",
    comingSoon: false,
    overview:
      "Vocational Studies offers bachelor's degrees focused on practical, industry-ready skills. Programs equip students with specialized knowledge and competencies for immediate employment or entrepreneurship across a wide range of trades and services.",
    degrees: [
      { name: "B.Voc. (Bachelor of Vocation)", duration: "3 Years", eligibility: "10+2 any stream" },
      { name: "B.A. (Vocational Studies)", duration: "3 Years", eligibility: "10+2 any stream" },
      { name: "B.Com. (Vocational)", duration: "3 Years", eligibility: "10+2 any stream" },
    ],
    specializations: [
      "Agriculture", "Aircraft Maintenance Engineering", "Analytics", "Automobile", "Banking/Financial Services (BFSI)",
      "Communication Design", "Construction Design", "Electronic Manufacturing Services", "Entertainment",
      "Food Processing", "Graphics and Multimedia", "Healthcare", "Home Science", "Industrial Tool Manufacturing",
      "Information Technology", "Marketing", "Mobile Communication", "Production Technology",
      "Refrigeration & Air Conditioning", "Secretarial Practice", "Telecommunication",
    ],
    careers: [
      "Higher Studies", "Job in Social Research", "Higher Studies in Management", "Research and Academics",
      "Banking / Insurance Job", "Indian Civil Services", "Indian Armed Forces", "Corporate Job",
      "Own Venture in Social Service", "Own Venture in the Skill Acquired", "Work in the Skill-Based Industry",
    ],
    exams: [
      { name: "CUET (UG)", url: "https://cuet.samarth.ac.in/" },
      { name: "JMI-ET", url: "https://www.jmi.ac.in/" },
    ],
    colleges: [
      c(1, "College of Vocational Studies", "Delhi", "CUET (UG)", "https://www.cvs.edu.in/"),
      c(2, "Alphonsa College", "Kottayam", "Based on 12th Marks", "https://www.alphonsacollege.in/"),
      c(3, "Andhra Loyola College", "Vijayawada", "Interview", "https://www.andhraloyolacollege.ac.in/"),
      c(4, "Arch College of Design and Business", "Jaipur", "Based on 12th Marks", "https://www.archedu.org/"),
      c(5, "Assam University", "Silchar", "Written Test & PI", "http://www.aus.ac.in/"),
      c(6, "Babasaheb Bhimrao Ambedkar University", "Lucknow", "CUET (UG)", "https://www.bbau.ac.in/"),
      c(7, "Central University of Gujarat", "Gandhinagar", "Based on 12th Marks", "https://www.cug.ac.in/"),
      c(8, "DAV College, Sector 10", "Chandigarh", "Based on 12th Marks", "https://www.davchd.ac.in/"),
      c(9, "Farook College", "Kozhikode", "Based on 12th Marks", "https://www.farookcollege.ac.in/"),
      c(10, "Fergusson College", "Pune", "Based on 12th Marks", "https://www.fergusson.edu/"),
      c(11, "Gandhigram Rural Institute", "Tamil Nadu", "Based on 12th Marks", "https://www.ruraluniv.ac.in/"),
      c(12, "Guru Gobind Singh Indraprastha University", "Delhi", "Based on 12th Marks", "http://www.ipu.ac.in/"),
      c(13, "H.R. College of Commerce & Economics", "Mumbai", "Based on 12th Marks", "https://www.hrcollege.edu/"),
      c(14, "Carmel College Mala", "Kerala", "Based on 12th Marks", "https://www.carmelcollegemala.ac.in/"),
    ],
  },
  {
    slug: "architecture-planning",
    name: "Architecture & Planning",
    category: "Design",
    icon: "Building2",
    comingSoon: false,
    overview:
      "Architecture combines creative expression with technology — architects design and model commercial and residential infrastructure. Employment in urban and regional planning is growing due to rising development and infrastructure needs, creating high demand for qualified professionals.",
    degrees: [
      { name: "B.Arch (Bachelor of Architecture)", duration: "5 Years", eligibility: "10+2 with PCM" },
      { name: "B.Plan (Bachelor of Planning)", duration: "4 Years", eligibility: "10+2 with Maths (any stream)" },
      { name: "B.Tech (Planning)", duration: "4 Years", eligibility: "10+2 with PCM" },
    ],
    specializations: ["Interior Design", "Landscape Design", "Spatial Design", "Urban & Regional Planning"],
    careers: [
      "Public Works Department", "Own Architectural Venture", "Builder / Construction Co.",
      "Professional Architect / Planner", "Research and Academics", "Higher Studies in Management",
      "Indian Armed Forces", "Higher Studies", "Indian Civil Services", "Merchant Navy",
      "Archaeological Survey of India", "Banking Job",
    ],
    exams: [
      { name: "JEE Main Paper 2A (B.Arch)", url: "https://jeemain.nta.nic.in/" },
      { name: "NATA", url: "https://www.nata.in/" },
      { name: "AAT (IIT B.Arch)", url: "https://www.jeeadv.ac.in/" },
      { name: "AMU-AAT", url: "https://www.amu.ac.in/" },
      { name: "JEE Main Paper 2B (Planning)", url: "https://jeemain.nta.nic.in/" },
      { name: "AP-EAPCET", url: "https://sche.ap.gov.in/EAPCET" },
      { name: "TS-EAMCET", url: "https://eamcet.tsche.ac.in/" },
    ],
    colleges: [
      c(1, "Sir J.J. College of Architecture", "Mumbai", "NATA / JEE Main Paper 2", "http://www.sirjjarchitecture.org/"),
      c(2, "School of Planning & Architecture", "New Delhi", "JEE-Main", "http://spa.ac.in/"),
      c(3, "Faculty of Architecture & Regional Planning, IIT", "Kharagpur", "AAT", "http://www.iitkgp.ac.in"),
      c(4, "Dept. of Architecture & Planning, IIT", "Roorkee", "AAT", "https://www.iitr.ac.in/"),
      c(5, "School of Planning & Architecture, JNAFAU", "Hyderabad", "NATA / JEE Paper 2", "https://www.jnafau.ac.in/"),
      c(6, "School of Architecture & Planning, Anna University", "Chennai", "NATA / JEE Paper 2", "https://www.annauniv.edu"),
      c(7, "Chandigarh College of Architecture", "Chandigarh", "JEE Main + JAC", "http://chdenggadmissions.nic.in/"),
      c(8, "Faculty of Architecture, CEPT University", "Ahmedabad", "NATA", "http://www.cept.ac.in"),
      c(9, "Dept. of Architecture, MANIT", "Bhopal", "NATA / JEE Main Paper 2", "http://www.manit.ac.in/"),
      c(10, "School of Planning & Architecture", "Bhopal", "JEE-Main", "http://spabhopal.ac.in/"),
      c(11, "School of Planning & Architecture", "Vijayawada", "JEE-Main", "https://www.spav.ac.in/"),
      c(12, "Dept. of Architecture, Jadavpur University", "Kolkata", "NATA / JEE + WBJEE", "http://www.jaduniv.edu.in/"),
      c(13, "Manipal School of Architecture & Planning", "Manipal", "NATA", "https://manipal.edu/"),
      c(14, "Faculty of Architecture & Ekistics, Jamia Millia Islamia", "New Delhi", "NATA / JEE Paper 2 + Interview", "https://www.jmi.ac.in/fae"),
      c(15, "Dept. of Architecture, NIT Trichy", "Tiruchirapalli", "JEE-Main", "http://www.nitt.edu"),
    ],
  },
  {
    slug: "agriculture-allied",
    name: "Agriculture & Allied Sciences",
    category: "Sciences",
    icon: "Sprout",
    comingSoon: false,
    overview:
      "India's agricultural sector needs skilled professionals to advance crop cultivation, harvesting and innovative farming. The field spans crop farming, forestry, agricultural biotechnology, plant breeding and soil science — improving crop products and developing effective farming solutions.",
    degrees: [
      { name: "B.Sc. (Agriculture)", duration: "4 Years", eligibility: "10+2 with PCM/B" },
      { name: "B.Sc. (Horticulture)", duration: "4 Years", eligibility: "10+2 with PCM/B" },
      { name: "B.Sc. (Forestry)", duration: "4 Years", eligibility: "10+2 with PCM/B" },
      { name: "B.Sc. (Sericulture)", duration: "4 Years", eligibility: "10+2 with PCM/B" },
      { name: "B.Tech. (Food Technology)", duration: "4 Years", eligibility: "10+2 with PCM/B" },
      { name: "B.Tech. (Dairy Technology)", duration: "4 Years", eligibility: "10+2 with PCM/B" },
      { name: "B.Tech. (Agriculture / Biotechnology)", duration: "4 Years", eligibility: "10+2 with PCM/B" },
    ],
    specializations: [
      "Agricultural Economics", "Agronomy", "Dairying", "Food Technology", "Irrigation & Drainage Engineering",
      "Plant Pathology", "Soil & Water Engineering", "Agricultural Extension Education", "Biochemistry",
      "Entomology", "Fruit Science", "Soil Science", "Agrometeorology", "Biotechnology",
      "Farm Machinery & Power Engineering", "Horticulture", "Microbiology", "Remote Sensing & GIS",
      "Vegetable Science", "Floriculture", "Plant Breeding & Genetics", "Poultry Science",
    ],
    careers: [
      "Indian Civil Services", "Higher Studies", "Indian Armed Forces", "Technical Writing", "Agricultural Journalism",
      "Chemical Manufacturing", "Cooperative Services", "Consultant to Corporates", "Higher Studies in Management",
      "Agricultural Research", "Teaching with Agriculture College", "Research and Development",
      "Agricultural Equipment Manufacturing", "Agriculture Production", "Agriculture Policy Making",
    ],
    exams: [
      { name: "ICAR-AIEEA UG", url: "https://icar.nta.ac.in/" },
      { name: "NEET UG", url: "https://neet.nta.nic.in/" },
      { name: "CUET (UG)", url: "https://cuet.samarth.ac.in/" },
      { name: "GBPUAT-CEE", url: "https://gbpuat.ac.in/" },
      { name: "AP-EAPCET", url: "https://sche.ap.gov.in/EAPCET" },
      { name: "AGRICET", url: "https://angrau.ac.in/" },
      { name: "MP-PAT", url: "http://www.peb.mp.gov.in/" },
      { name: "MHT-CET", url: "http://cetcell.mahacet.org" },
      { name: "KEA-CET", url: "https://cetonline.karnataka.gov.in/kea/" },
      { name: "OUAT", url: "http://ouat.nic.in/" },
    ],
    colleges: [
      c(1, "G.B. Pant University of Agriculture & Technology", "Pantnagar", "GBPUAT-CEE", "https://gbpuat.ac.in/"),
      c(2, "Chaudhary Charan Singh Haryana Agricultural University", "Hisar", "HAU-ET / JEE-Main", "http://www.hau.ac.in/"),
      c(3, "University of Agricultural Sciences", "Bangalore", "KAR-CET Agri", "https://uasbangalore.edu.in/"),
      c(4, "Tamil Nadu Agricultural University", "Coimbatore", "ICAR-AIEEA / Merit", "https://tnau.ac.in/"),
      c(5, "Tamil Nadu Veterinary & Animal Sciences University", "Chennai", "ICAR-AIEEA / Merit", "https://tanuvas.ac.in/"),
      c(6, "Professor Jayashankar Telangana State Agricultural University", "Hyderabad", "TS-EAMCET", "https://www.pjtsau.edu.in/"),
      c(7, "University of Horticulture Science", "Bagalkot", "KAR-CET Agri", "http://www.uhsbagalkot.edu.in/"),
      c(8, "Kerala Agricultural University", "Thrissur", "KEAM / ICAR-AIEEA", "http://www.kau.in/"),
      c(9, "ICAR-National Dairy Research Institute", "Karnal", "ICAR-AIEEA", "http://ndri.res.in/"),
      c(10, "Sher-e-Kashmir University of Agricultural Science & Technology", "Jammu", "SKUAST-J CET / ICAR", "https://skuast.org/"),
      c(11, "Maharashtra Animal & Fisheries Sciences University", "Nagpur", "NEET / MHT-CET", "http://www.mafsu.in/"),
      c(12, "Jawaharlal Nehru Krishi Vishwa Vidyalaya", "Jabalpur", "MP-PAT / ICAR-AIEEA", "http://www.jnkvv.org/"),
      c(13, "Lala Lajpat Rai University of Veterinary & Animal Sciences", "Hisar", "NEET / JEE-Main", "https://www.luvas.edu.in/"),
      c(14, "Anand Agricultural University", "Anand", "GUJCET", "http://www.aau.in/"),
      c(15, "Navsari Agricultural University", "Navsari", "GUJCET", "https://nau.in/"),
    ],
  },
];

export const getVertical = (slug) => VERTICALS.find((v) => v.slug === slug);
